var varioSettings = [];
var varioCustomizer = {
  swatches: {
    size: "large",
    style: "circle",
    border_color: { normal: "#e4e4e4", active: "#4f5354" },
    hover_effect: "none",
    image_position: "fit",
    border_style: "single",
    border_inner_color: { normal: "#fff", active: "#fff" },
  },
  sold_out: {
    show_sold_out_variants: true,
    style: "cross",
    hide_style: "automatic",
  },
  collection: {
    image_size: 240,
    swatch_size: "medium",
    show_label: true,
    limit_swatches: false,
    number_of_swatches: 0,
    number_of_buttons: 0,
    plus_button_action: "do_nothing",
  },
};
var VarioCurrencyFormat = "<span class=money>Rs. {{amount}}</span>";
(() => {
  "use strict";
  function t(t) {
    if (null == t) return window;
    if ("[object Window]" !== t.toString()) {
      var e = t.ownerDocument;
      return (e && e.defaultView) || window;
    }
    return t;
  }
  function e(e) {
    return e instanceof t(e).Element || e instanceof Element;
  }
  function r(e) {
    return e instanceof t(e).HTMLElement || e instanceof HTMLElement;
  }
  function n(e) {
    return (
      "undefined" != typeof ShadowRoot &&
      (e instanceof t(e).ShadowRoot || e instanceof ShadowRoot)
    );
  }
  var i = Math.max,
    o = Math.min,
    a = Math.round;
  function s(t, e) {
    void 0 === e && (e = !1);
    var n = t.getBoundingClientRect(),
      i = 1,
      o = 1;
    if (r(t) && e) {
      var s = t.offsetHeight,
        u = t.offsetWidth;
      u > 0 && (i = a(n.width) / u || 1), s > 0 && (o = a(n.height) / s || 1);
    }
    return {
      width: n.width / i,
      height: n.height / o,
      top: n.top / o,
      right: n.right / i,
      bottom: n.bottom / o,
      left: n.left / i,
      x: n.left / i,
      y: n.top / o,
    };
  }
  function u(e) {
    var r = t(e);
    return { scrollLeft: r.pageXOffset, scrollTop: r.pageYOffset };
  }
  function c(t) {
    return t ? (t.nodeName || "").toLowerCase() : null;
  }
  function l(t) {
    return ((e(t) ? t.ownerDocument : t.document) || window.document)
      .documentElement;
  }
  function p(t) {
    return s(l(t)).left + u(t).scrollLeft;
  }
  function f(e) {
    return t(e).getComputedStyle(e);
  }
  function d(t) {
    var e = f(t),
      r = e.overflow,
      n = e.overflowX,
      i = e.overflowY;
    return /auto|scroll|overlay|hidden/.test(r + i + n);
  }
  function h(e, n, i) {
    void 0 === i && (i = !1);
    var o,
      f,
      h = r(n),
      v =
        r(n) &&
        (function (t) {
          var e = t.getBoundingClientRect(),
            r = a(e.width) / t.offsetWidth || 1,
            n = a(e.height) / t.offsetHeight || 1;
          return 1 !== r || 1 !== n;
        })(n),
      m = l(n),
      g = s(e, v),
      y = { scrollLeft: 0, scrollTop: 0 },
      w = { x: 0, y: 0 };
    return (
      (h || (!h && !i)) &&
        (("body" !== c(n) || d(m)) &&
          (y =
            (o = n) !== t(o) && r(o)
              ? { scrollLeft: (f = o).scrollLeft, scrollTop: f.scrollTop }
              : u(o)),
        r(n)
          ? (((w = s(n, !0)).x += n.clientLeft), (w.y += n.clientTop))
          : m && (w.x = p(m))),
      {
        x: g.left + y.scrollLeft - w.x,
        y: g.top + y.scrollTop - w.y,
        width: g.width,
        height: g.height,
      }
    );
  }
  function v(t) {
    var e = s(t),
      r = t.offsetWidth,
      n = t.offsetHeight;
    return (
      Math.abs(e.width - r) <= 1 && (r = e.width),
      Math.abs(e.height - n) <= 1 && (n = e.height),
      { x: t.offsetLeft, y: t.offsetTop, width: r, height: n }
    );
  }
  function m(t) {
    return "html" === c(t)
      ? t
      : t.assignedSlot || t.parentNode || (n(t) ? t.host : null) || l(t);
  }
  function g(t) {
    return ["html", "body", "#document"].indexOf(c(t)) >= 0
      ? t.ownerDocument.body
      : r(t) && d(t)
      ? t
      : g(m(t));
  }
  function y(e, r) {
    var n;
    void 0 === r && (r = []);
    var i = g(e),
      o = i === (null == (n = e.ownerDocument) ? void 0 : n.body),
      a = t(i),
      s = o ? [a].concat(a.visualViewport || [], d(i) ? i : []) : i,
      u = r.concat(s);
    return o ? u : u.concat(y(m(s)));
  }
  function w(t) {
    return ["table", "td", "th"].indexOf(c(t)) >= 0;
  }
  function b(t) {
    return r(t) && "fixed" !== f(t).position ? t.offsetParent : null;
  }
  function _(e) {
    for (var n = t(e), i = b(e); i && w(i) && "static" === f(i).position; )
      i = b(i);
    return i &&
      ("html" === c(i) || ("body" === c(i) && "static" === f(i).position))
      ? n
      : i ||
          (function (t) {
            var e = -1 !== navigator.userAgent.toLowerCase().indexOf("firefox");
            if (
              -1 !== navigator.userAgent.indexOf("Trident") &&
              r(t) &&
              "fixed" === f(t).position
            )
              return null;
            for (var n = m(t); r(n) && ["html", "body"].indexOf(c(n)) < 0; ) {
              var i = f(n);
              if (
                "none" !== i.transform ||
                "none" !== i.perspective ||
                "paint" === i.contain ||
                -1 !== ["transform", "perspective"].indexOf(i.willChange) ||
                (e && "filter" === i.willChange) ||
                (e && i.filter && "none" !== i.filter)
              )
                return n;
              n = n.parentNode;
            }
            return null;
          })(e) ||
          n;
  }
  var S = "top",
    x = "bottom",
    T = "right",
    O = "left",
    k = "auto",
    q = [S, x, T, O],
    E = "start",
    A = "end",
    L = "viewport",
    P = "popper",
    F = q.reduce(function (t, e) {
      return t.concat([e + "-" + E, e + "-" + A]);
    }, []),
    C = [].concat(q, [k]).reduce(function (t, e) {
      return t.concat([e, e + "-" + E, e + "-" + A]);
    }, []),
    N = [
      "beforeRead",
      "read",
      "afterRead",
      "beforeMain",
      "main",
      "afterMain",
      "beforeWrite",
      "write",
      "afterWrite",
    ];
  function j(t) {
    var e = new Map(),
      r = new Set(),
      n = [];
    function i(t) {
      r.add(t.name),
        []
          .concat(t.requires || [], t.requiresIfExists || [])
          .forEach(function (t) {
            if (!r.has(t)) {
              var n = e.get(t);
              n && i(n);
            }
          }),
        n.push(t);
    }
    return (
      t.forEach(function (t) {
        e.set(t.name, t);
      }),
      t.forEach(function (t) {
        r.has(t.name) || i(t);
      }),
      n
    );
  }
  var R = { placement: "bottom", modifiers: [], strategy: "absolute" };
  function D() {
    for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
      e[r] = arguments[r];
    return !e.some(function (t) {
      return !(t && "function" == typeof t.getBoundingClientRect);
    });
  }
  function M(t) {
    void 0 === t && (t = {});
    var r = t,
      n = r.defaultModifiers,
      i = void 0 === n ? [] : n,
      o = r.defaultOptions,
      a = void 0 === o ? R : o;
    return function (t, r, n) {
      void 0 === n && (n = a);
      var o,
        s,
        u = {
          placement: "bottom",
          orderedModifiers: [],
          options: Object.assign({}, R, a),
          modifiersData: {},
          elements: { reference: t, popper: r },
          attributes: {},
          styles: {},
        },
        c = [],
        l = !1,
        p = {
          state: u,
          setOptions: function (n) {
            var o = "function" == typeof n ? n(u.options) : n;
            f(),
              (u.options = Object.assign({}, a, u.options, o)),
              (u.scrollParents = {
                reference: e(t)
                  ? y(t)
                  : t.contextElement
                  ? y(t.contextElement)
                  : [],
                popper: y(r),
              });
            var s = (function (t) {
              var e = j(t);
              return N.reduce(function (t, r) {
                return t.concat(
                  e.filter(function (t) {
                    return t.phase === r;
                  })
                );
              }, []);
            })(
              (function (t) {
                var e = t.reduce(function (t, e) {
                  var r = t[e.name];
                  return (
                    (t[e.name] = r
                      ? Object.assign({}, r, e, {
                          options: Object.assign({}, r.options, e.options),
                          data: Object.assign({}, r.data, e.data),
                        })
                      : e),
                    t
                  );
                }, {});
                return Object.keys(e).map(function (t) {
                  return e[t];
                });
              })([].concat(i, u.options.modifiers))
            );
            return (
              (u.orderedModifiers = s.filter(function (t) {
                return t.enabled;
              })),
              u.orderedModifiers.forEach(function (t) {
                var e = t.name,
                  r = t.options,
                  n = void 0 === r ? {} : r,
                  i = t.effect;
                if ("function" == typeof i) {
                  var o = i({ state: u, name: e, instance: p, options: n }),
                    a = function () {};
                  c.push(o || a);
                }
              }),
              p.update()
            );
          },
          forceUpdate: function () {
            if (!l) {
              var t = u.elements,
                e = t.reference,
                r = t.popper;
              if (D(e, r)) {
                (u.rects = {
                  reference: h(e, _(r), "fixed" === u.options.strategy),
                  popper: v(r),
                }),
                  (u.reset = !1),
                  (u.placement = u.options.placement),
                  u.orderedModifiers.forEach(function (t) {
                    return (u.modifiersData[t.name] = Object.assign(
                      {},
                      t.data
                    ));
                  });
                for (var n = 0; n < u.orderedModifiers.length; n++)
                  if (!0 !== u.reset) {
                    var i = u.orderedModifiers[n],
                      o = i.fn,
                      a = i.options,
                      s = void 0 === a ? {} : a,
                      c = i.name;
                    "function" == typeof o &&
                      (u =
                        o({ state: u, options: s, name: c, instance: p }) || u);
                  } else (u.reset = !1), (n = -1);
              }
            }
          },
          update:
            ((o = function () {
              return new Promise(function (t) {
                p.forceUpdate(), t(u);
              });
            }),
            function () {
              return (
                s ||
                  (s = new Promise(function (t) {
                    Promise.resolve().then(function () {
                      (s = void 0), t(o());
                    });
                  })),
                s
              );
            }),
          destroy: function () {
            f(), (l = !0);
          },
        };
      if (!D(t, r)) return p;
      function f() {
        c.forEach(function (t) {
          return t();
        }),
          (c = []);
      }
      return (
        p.setOptions(n).then(function (t) {
          !l && n.onFirstUpdate && n.onFirstUpdate(t);
        }),
        p
      );
    };
  }
  var I = { passive: !0 };
  function V(t) {
    return t.split("-")[0];
  }
  function B(t) {
    return t.split("-")[1];
  }
  function z(t) {
    return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
  }
  function H(t) {
    var e,
      r = t.reference,
      n = t.element,
      i = t.placement,
      o = i ? V(i) : null,
      a = i ? B(i) : null,
      s = r.x + r.width / 2 - n.width / 2,
      u = r.y + r.height / 2 - n.height / 2;
    switch (o) {
      case S:
        e = { x: s, y: r.y - n.height };
        break;
      case x:
        e = { x: s, y: r.y + r.height };
        break;
      case T:
        e = { x: r.x + r.width, y: u };
        break;
      case O:
        e = { x: r.x - n.width, y: u };
        break;
      default:
        e = { x: r.x, y: r.y };
    }
    var c = o ? z(o) : null;
    if (null != c) {
      var l = "y" === c ? "height" : "width";
      switch (a) {
        case E:
          e[c] = e[c] - (r[l] / 2 - n[l] / 2);
          break;
        case A:
          e[c] = e[c] + (r[l] / 2 - n[l] / 2);
      }
    }
    return e;
  }
  var W = { top: "auto", right: "auto", bottom: "auto", left: "auto" };
  function U(e) {
    var r,
      n = e.popper,
      i = e.popperRect,
      o = e.placement,
      s = e.variation,
      u = e.offsets,
      c = e.position,
      p = e.gpuAcceleration,
      d = e.adaptive,
      h = e.roundOffsets,
      v = e.isFixed,
      m = u.x,
      g = void 0 === m ? 0 : m,
      y = u.y,
      w = void 0 === y ? 0 : y,
      b = "function" == typeof h ? h({ x: g, y: w }) : { x: g, y: w };
    (g = b.x), (w = b.y);
    var k = u.hasOwnProperty("x"),
      q = u.hasOwnProperty("y"),
      E = O,
      L = S,
      P = window;
    if (d) {
      var F = _(n),
        C = "clientHeight",
        N = "clientWidth";
      if (
        (F === t(n) &&
          "static" !== f((F = l(n))).position &&
          "absolute" === c &&
          ((C = "scrollHeight"), (N = "scrollWidth")),
        (F = F),
        o === S || ((o === O || o === T) && s === A))
      )
        (L = x),
          (w -=
            (v && P.visualViewport ? P.visualViewport.height : F[C]) -
            i.height),
          (w *= p ? 1 : -1);
      if (o === O || ((o === S || o === x) && s === A))
        (E = T),
          (g -=
            (v && P.visualViewport ? P.visualViewport.width : F[N]) - i.width),
          (g *= p ? 1 : -1);
    }
    var j,
      R = Object.assign({ position: c }, d && W),
      D =
        !0 === h
          ? (function (t) {
              var e = t.x,
                r = t.y,
                n = window.devicePixelRatio || 1;
              return { x: a(e * n) / n || 0, y: a(r * n) / n || 0 };
            })({ x: g, y: w })
          : { x: g, y: w };
    return (
      (g = D.x),
      (w = D.y),
      p
        ? Object.assign(
            {},
            R,
            (((j = {})[L] = q ? "0" : ""),
            (j[E] = k ? "0" : ""),
            (j.transform =
              (P.devicePixelRatio || 1) <= 1
                ? "translate(" + g + "px, " + w + "px)"
                : "translate3d(" + g + "px, " + w + "px, 0)"),
            j)
          )
        : Object.assign(
            {},
            R,
            (((r = {})[L] = q ? w + "px" : ""),
            (r[E] = k ? g + "px" : ""),
            (r.transform = ""),
            r)
          )
    );
  }
  const J = {
    name: "offset",
    enabled: !0,
    phase: "main",
    requires: ["popperOffsets"],
    fn: function (t) {
      var e = t.state,
        r = t.options,
        n = t.name,
        i = r.offset,
        o = void 0 === i ? [0, 0] : i,
        a = C.reduce(function (t, r) {
          return (
            (t[r] = (function (t, e, r) {
              var n = V(t),
                i = [O, S].indexOf(n) >= 0 ? -1 : 1,
                o =
                  "function" == typeof r
                    ? r(Object.assign({}, e, { placement: t }))
                    : r,
                a = o[0],
                s = o[1];
              return (
                (a = a || 0),
                (s = (s || 0) * i),
                [O, T].indexOf(n) >= 0 ? { x: s, y: a } : { x: a, y: s }
              );
            })(r, e.rects, o)),
            t
          );
        }, {}),
        s = a[e.placement],
        u = s.x,
        c = s.y;
      null != e.modifiersData.popperOffsets &&
        ((e.modifiersData.popperOffsets.x += u),
        (e.modifiersData.popperOffsets.y += c)),
        (e.modifiersData[n] = a);
    },
  };
  var Y = { left: "right", right: "left", bottom: "top", top: "bottom" };
  function $(t) {
    return t.replace(/left|right|bottom|top/g, function (t) {
      return Y[t];
    });
  }
  var G = { start: "end", end: "start" };
  function Q(t) {
    return t.replace(/start|end/g, function (t) {
      return G[t];
    });
  }
  function X(t, e) {
    var r = e.getRootNode && e.getRootNode();
    if (t.contains(e)) return !0;
    if (r && n(r)) {
      var i = e;
      do {
        if (i && t.isSameNode(i)) return !0;
        i = i.parentNode || i.host;
      } while (i);
    }
    return !1;
  }
  function Z(t) {
    return Object.assign({}, t, {
      left: t.x,
      top: t.y,
      right: t.x + t.width,
      bottom: t.y + t.height,
    });
  }
  function K(r, n) {
    return n === L
      ? Z(
          (function (e) {
            var r = t(e),
              n = l(e),
              i = r.visualViewport,
              o = n.clientWidth,
              a = n.clientHeight,
              s = 0,
              u = 0;
            return (
              i &&
                ((o = i.width),
                (a = i.height),
                /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ||
                  ((s = i.offsetLeft), (u = i.offsetTop))),
              { width: o, height: a, x: s + p(e), y: u }
            );
          })(r)
        )
      : e(n)
      ? (function (t) {
          var e = s(t);
          return (
            (e.top = e.top + t.clientTop),
            (e.left = e.left + t.clientLeft),
            (e.bottom = e.top + t.clientHeight),
            (e.right = e.left + t.clientWidth),
            (e.width = t.clientWidth),
            (e.height = t.clientHeight),
            (e.x = e.left),
            (e.y = e.top),
            e
          );
        })(n)
      : Z(
          (function (t) {
            var e,
              r = l(t),
              n = u(t),
              o = null == (e = t.ownerDocument) ? void 0 : e.body,
              a = i(
                r.scrollWidth,
                r.clientWidth,
                o ? o.scrollWidth : 0,
                o ? o.clientWidth : 0
              ),
              s = i(
                r.scrollHeight,
                r.clientHeight,
                o ? o.scrollHeight : 0,
                o ? o.clientHeight : 0
              ),
              c = -n.scrollLeft + p(t),
              d = -n.scrollTop;
            return (
              "rtl" === f(o || r).direction &&
                (c += i(r.clientWidth, o ? o.clientWidth : 0) - a),
              { width: a, height: s, x: c, y: d }
            );
          })(l(r))
        );
  }
  function tt(t, n, a) {
    var s =
        "clippingParents" === n
          ? (function (t) {
              var n = y(m(t)),
                i =
                  ["absolute", "fixed"].indexOf(f(t).position) >= 0 && r(t)
                    ? _(t)
                    : t;
              return e(i)
                ? n.filter(function (t) {
                    return e(t) && X(t, i) && "body" !== c(t);
                  })
                : [];
            })(t)
          : [].concat(n),
      u = [].concat(s, [a]),
      l = u[0],
      p = u.reduce(function (e, r) {
        var n = K(t, r);
        return (
          (e.top = i(n.top, e.top)),
          (e.right = o(n.right, e.right)),
          (e.bottom = o(n.bottom, e.bottom)),
          (e.left = i(n.left, e.left)),
          e
        );
      }, K(t, l));
    return (
      (p.width = p.right - p.left),
      (p.height = p.bottom - p.top),
      (p.x = p.left),
      (p.y = p.top),
      p
    );
  }
  function et(t) {
    return Object.assign({}, { top: 0, right: 0, bottom: 0, left: 0 }, t);
  }
  function rt(t, e) {
    return e.reduce(function (e, r) {
      return (e[r] = t), e;
    }, {});
  }
  function nt(t, r) {
    void 0 === r && (r = {});
    var n = r,
      i = n.placement,
      o = void 0 === i ? t.placement : i,
      a = n.boundary,
      u = void 0 === a ? "clippingParents" : a,
      c = n.rootBoundary,
      p = void 0 === c ? L : c,
      f = n.elementContext,
      d = void 0 === f ? P : f,
      h = n.altBoundary,
      v = void 0 !== h && h,
      m = n.padding,
      g = void 0 === m ? 0 : m,
      y = et("number" != typeof g ? g : rt(g, q)),
      w = d === P ? "reference" : P,
      b = t.rects.popper,
      _ = t.elements[v ? w : d],
      O = tt(e(_) ? _ : _.contextElement || l(t.elements.popper), u, p),
      k = s(t.elements.reference),
      E = H({ reference: k, element: b, strategy: "absolute", placement: o }),
      A = Z(Object.assign({}, b, E)),
      F = d === P ? A : k,
      C = {
        top: O.top - F.top + y.top,
        bottom: F.bottom - O.bottom + y.bottom,
        left: O.left - F.left + y.left,
        right: F.right - O.right + y.right,
      },
      N = t.modifiersData.offset;
    if (d === P && N) {
      var j = N[o];
      Object.keys(C).forEach(function (t) {
        var e = [T, x].indexOf(t) >= 0 ? 1 : -1,
          r = [S, x].indexOf(t) >= 0 ? "y" : "x";
        C[t] += j[r] * e;
      });
    }
    return C;
  }
  function it(t, e, r) {
    return i(t, o(e, r));
  }
  const ot = {
    name: "preventOverflow",
    enabled: !0,
    phase: "main",
    fn: function (t) {
      var e = t.state,
        r = t.options,
        n = t.name,
        a = r.mainAxis,
        s = void 0 === a || a,
        u = r.altAxis,
        c = void 0 !== u && u,
        l = r.boundary,
        p = r.rootBoundary,
        f = r.altBoundary,
        d = r.padding,
        h = r.tether,
        m = void 0 === h || h,
        g = r.tetherOffset,
        y = void 0 === g ? 0 : g,
        w = nt(e, { boundary: l, rootBoundary: p, padding: d, altBoundary: f }),
        b = V(e.placement),
        k = B(e.placement),
        q = !k,
        A = z(b),
        L = "x" === A ? "y" : "x",
        P = e.modifiersData.popperOffsets,
        F = e.rects.reference,
        C = e.rects.popper,
        N =
          "function" == typeof y
            ? y(Object.assign({}, e.rects, { placement: e.placement }))
            : y,
        j =
          "number" == typeof N
            ? { mainAxis: N, altAxis: N }
            : Object.assign({ mainAxis: 0, altAxis: 0 }, N),
        R = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null,
        D = { x: 0, y: 0 };
      if (P) {
        if (s) {
          var M,
            I = "y" === A ? S : O,
            H = "y" === A ? x : T,
            W = "y" === A ? "height" : "width",
            U = P[A],
            J = U + w[I],
            Y = U - w[H],
            $ = m ? -C[W] / 2 : 0,
            G = k === E ? F[W] : C[W],
            Q = k === E ? -C[W] : -F[W],
            X = e.elements.arrow,
            Z = m && X ? v(X) : { width: 0, height: 0 },
            K = e.modifiersData["arrow#persistent"]
              ? e.modifiersData["arrow#persistent"].padding
              : { top: 0, right: 0, bottom: 0, left: 0 },
            tt = K[I],
            et = K[H],
            rt = it(0, F[W], Z[W]),
            ot = q
              ? F[W] / 2 - $ - rt - tt - j.mainAxis
              : G - rt - tt - j.mainAxis,
            at = q
              ? -F[W] / 2 + $ + rt + et + j.mainAxis
              : Q + rt + et + j.mainAxis,
            st = e.elements.arrow && _(e.elements.arrow),
            ut = st ? ("y" === A ? st.clientTop || 0 : st.clientLeft || 0) : 0,
            ct = null != (M = null == R ? void 0 : R[A]) ? M : 0,
            lt = U + at - ct,
            pt = it(m ? o(J, U + ot - ct - ut) : J, U, m ? i(Y, lt) : Y);
          (P[A] = pt), (D[A] = pt - U);
        }
        if (c) {
          var ft,
            dt = "x" === A ? S : O,
            ht = "x" === A ? x : T,
            vt = P[L],
            mt = "y" === L ? "height" : "width",
            gt = vt + w[dt],
            yt = vt - w[ht],
            wt = -1 !== [S, O].indexOf(b),
            bt = null != (ft = null == R ? void 0 : R[L]) ? ft : 0,
            _t = wt ? gt : vt - F[mt] - C[mt] - bt + j.altAxis,
            St = wt ? vt + F[mt] + C[mt] - bt - j.altAxis : yt,
            xt =
              m && wt
                ? (function (t, e, r) {
                    var n = it(t, e, r);
                    return n > r ? r : n;
                  })(_t, vt, St)
                : it(m ? _t : gt, vt, m ? St : yt);
          (P[L] = xt), (D[L] = xt - vt);
        }
        e.modifiersData[n] = D;
      }
    },
    requiresIfExists: ["offset"],
  };
  const at = {
    name: "arrow",
    enabled: !0,
    phase: "main",
    fn: function (t) {
      var e,
        r = t.state,
        n = t.name,
        i = t.options,
        o = r.elements.arrow,
        a = r.modifiersData.popperOffsets,
        s = V(r.placement),
        u = z(s),
        c = [O, T].indexOf(s) >= 0 ? "height" : "width";
      if (o && a) {
        var l = (function (t, e) {
            return et(
              "number" !=
                typeof (t =
                  "function" == typeof t
                    ? t(Object.assign({}, e.rects, { placement: e.placement }))
                    : t)
                ? t
                : rt(t, q)
            );
          })(i.padding, r),
          p = v(o),
          f = "y" === u ? S : O,
          d = "y" === u ? x : T,
          h =
            r.rects.reference[c] +
            r.rects.reference[u] -
            a[u] -
            r.rects.popper[c],
          m = a[u] - r.rects.reference[u],
          g = _(o),
          y = g ? ("y" === u ? g.clientHeight || 0 : g.clientWidth || 0) : 0,
          w = h / 2 - m / 2,
          b = l[f],
          k = y - p[c] - l[d],
          E = y / 2 - p[c] / 2 + w,
          A = it(b, E, k),
          L = u;
        r.modifiersData[n] = (((e = {})[L] = A), (e.centerOffset = A - E), e);
      }
    },
    effect: function (t) {
      var e = t.state,
        r = t.options.element,
        n = void 0 === r ? "[data-popper-arrow]" : r;
      null != n &&
        ("string" != typeof n || (n = e.elements.popper.querySelector(n))) &&
        X(e.elements.popper, n) &&
        (e.elements.arrow = n);
    },
    requires: ["popperOffsets"],
    requiresIfExists: ["preventOverflow"],
  };
  function st(t, e, r) {
    return (
      void 0 === r && (r = { x: 0, y: 0 }),
      {
        top: t.top - e.height - r.y,
        right: t.right - e.width + r.x,
        bottom: t.bottom - e.height + r.y,
        left: t.left - e.width - r.x,
      }
    );
  }
  function ut(t) {
    return [S, T, x, O].some(function (e) {
      return t[e] >= 0;
    });
  }
  var ct = M({
      defaultModifiers: [
        {
          name: "eventListeners",
          enabled: !0,
          phase: "write",
          fn: function () {},
          effect: function (e) {
            var r = e.state,
              n = e.instance,
              i = e.options,
              o = i.scroll,
              a = void 0 === o || o,
              s = i.resize,
              u = void 0 === s || s,
              c = t(r.elements.popper),
              l = [].concat(r.scrollParents.reference, r.scrollParents.popper);
            return (
              a &&
                l.forEach(function (t) {
                  t.addEventListener("scroll", n.update, I);
                }),
              u && c.addEventListener("resize", n.update, I),
              function () {
                a &&
                  l.forEach(function (t) {
                    t.removeEventListener("scroll", n.update, I);
                  }),
                  u && c.removeEventListener("resize", n.update, I);
              }
            );
          },
          data: {},
        },
        {
          name: "popperOffsets",
          enabled: !0,
          phase: "read",
          fn: function (t) {
            var e = t.state,
              r = t.name;
            e.modifiersData[r] = H({
              reference: e.rects.reference,
              element: e.rects.popper,
              strategy: "absolute",
              placement: e.placement,
            });
          },
          data: {},
        },
        {
          name: "computeStyles",
          enabled: !0,
          phase: "beforeWrite",
          fn: function (t) {
            var e = t.state,
              r = t.options,
              n = r.gpuAcceleration,
              i = void 0 === n || n,
              o = r.adaptive,
              a = void 0 === o || o,
              s = r.roundOffsets,
              u = void 0 === s || s,
              c = {
                placement: V(e.placement),
                variation: B(e.placement),
                popper: e.elements.popper,
                popperRect: e.rects.popper,
                gpuAcceleration: i,
                isFixed: "fixed" === e.options.strategy,
              };
            null != e.modifiersData.popperOffsets &&
              (e.styles.popper = Object.assign(
                {},
                e.styles.popper,
                U(
                  Object.assign({}, c, {
                    offsets: e.modifiersData.popperOffsets,
                    position: e.options.strategy,
                    adaptive: a,
                    roundOffsets: u,
                  })
                )
              )),
              null != e.modifiersData.arrow &&
                (e.styles.arrow = Object.assign(
                  {},
                  e.styles.arrow,
                  U(
                    Object.assign({}, c, {
                      offsets: e.modifiersData.arrow,
                      position: "absolute",
                      adaptive: !1,
                      roundOffsets: u,
                    })
                  )
                )),
              (e.attributes.popper = Object.assign({}, e.attributes.popper, {
                "data-popper-placement": e.placement,
              }));
          },
          data: {},
        },
        {
          name: "applyStyles",
          enabled: !0,
          phase: "write",
          fn: function (t) {
            var e = t.state;
            Object.keys(e.elements).forEach(function (t) {
              var n = e.styles[t] || {},
                i = e.attributes[t] || {},
                o = e.elements[t];
              r(o) &&
                c(o) &&
                (Object.assign(o.style, n),
                Object.keys(i).forEach(function (t) {
                  var e = i[t];
                  !1 === e
                    ? o.removeAttribute(t)
                    : o.setAttribute(t, !0 === e ? "" : e);
                }));
            });
          },
          effect: function (t) {
            var e = t.state,
              n = {
                popper: {
                  position: e.options.strategy,
                  left: "0",
                  top: "0",
                  margin: "0",
                },
                arrow: { position: "absolute" },
                reference: {},
              };
            return (
              Object.assign(e.elements.popper.style, n.popper),
              (e.styles = n),
              e.elements.arrow &&
                Object.assign(e.elements.arrow.style, n.arrow),
              function () {
                Object.keys(e.elements).forEach(function (t) {
                  var i = e.elements[t],
                    o = e.attributes[t] || {},
                    a = Object.keys(
                      e.styles.hasOwnProperty(t) ? e.styles[t] : n[t]
                    ).reduce(function (t, e) {
                      return (t[e] = ""), t;
                    }, {});
                  r(i) &&
                    c(i) &&
                    (Object.assign(i.style, a),
                    Object.keys(o).forEach(function (t) {
                      i.removeAttribute(t);
                    }));
                });
              }
            );
          },
          requires: ["computeStyles"],
        },
        J,
        {
          name: "flip",
          enabled: !0,
          phase: "main",
          fn: function (t) {
            var e = t.state,
              r = t.options,
              n = t.name;
            if (!e.modifiersData[n]._skip) {
              for (
                var i = r.mainAxis,
                  o = void 0 === i || i,
                  a = r.altAxis,
                  s = void 0 === a || a,
                  u = r.fallbackPlacements,
                  c = r.padding,
                  l = r.boundary,
                  p = r.rootBoundary,
                  f = r.altBoundary,
                  d = r.flipVariations,
                  h = void 0 === d || d,
                  v = r.allowedAutoPlacements,
                  m = e.options.placement,
                  g = V(m),
                  y =
                    u ||
                    (g === m || !h
                      ? [$(m)]
                      : (function (t) {
                          if (V(t) === k) return [];
                          var e = $(t);
                          return [Q(t), e, Q(e)];
                        })(m)),
                  w = [m].concat(y).reduce(function (t, r) {
                    return t.concat(
                      V(r) === k
                        ? (function (t, e) {
                            void 0 === e && (e = {});
                            var r = e,
                              n = r.placement,
                              i = r.boundary,
                              o = r.rootBoundary,
                              a = r.padding,
                              s = r.flipVariations,
                              u = r.allowedAutoPlacements,
                              c = void 0 === u ? C : u,
                              l = B(n),
                              p = l
                                ? s
                                  ? F
                                  : F.filter(function (t) {
                                      return B(t) === l;
                                    })
                                : q,
                              f = p.filter(function (t) {
                                return c.indexOf(t) >= 0;
                              });
                            0 === f.length && (f = p);
                            var d = f.reduce(function (e, r) {
                              return (
                                (e[r] = nt(t, {
                                  placement: r,
                                  boundary: i,
                                  rootBoundary: o,
                                  padding: a,
                                })[V(r)]),
                                e
                              );
                            }, {});
                            return Object.keys(d).sort(function (t, e) {
                              return d[t] - d[e];
                            });
                          })(e, {
                            placement: r,
                            boundary: l,
                            rootBoundary: p,
                            padding: c,
                            flipVariations: h,
                            allowedAutoPlacements: v,
                          })
                        : r
                    );
                  }, []),
                  b = e.rects.reference,
                  _ = e.rects.popper,
                  A = new Map(),
                  L = !0,
                  P = w[0],
                  N = 0;
                N < w.length;
                N++
              ) {
                var j = w[N],
                  R = V(j),
                  D = B(j) === E,
                  M = [S, x].indexOf(R) >= 0,
                  I = M ? "width" : "height",
                  z = nt(e, {
                    placement: j,
                    boundary: l,
                    rootBoundary: p,
                    altBoundary: f,
                    padding: c,
                  }),
                  H = M ? (D ? T : O) : D ? x : S;
                b[I] > _[I] && (H = $(H));
                var W = $(H),
                  U = [];
                if (
                  (o && U.push(z[R] <= 0),
                  s && U.push(z[H] <= 0, z[W] <= 0),
                  U.every(function (t) {
                    return t;
                  }))
                ) {
                  (P = j), (L = !1);
                  break;
                }
                A.set(j, U);
              }
              if (L)
                for (
                  var J = function (t) {
                      var e = w.find(function (e) {
                        var r = A.get(e);
                        if (r)
                          return r.slice(0, t).every(function (t) {
                            return t;
                          });
                      });
                      if (e) return (P = e), "break";
                    },
                    Y = h ? 3 : 1;
                  Y > 0;
                  Y--
                ) {
                  if ("break" === J(Y)) break;
                }
              e.placement !== P &&
                ((e.modifiersData[n]._skip = !0),
                (e.placement = P),
                (e.reset = !0));
            }
          },
          requiresIfExists: ["offset"],
          data: { _skip: !1 },
        },
        ot,
        at,
        {
          name: "hide",
          enabled: !0,
          phase: "main",
          requiresIfExists: ["preventOverflow"],
          fn: function (t) {
            var e = t.state,
              r = t.name,
              n = e.rects.reference,
              i = e.rects.popper,
              o = e.modifiersData.preventOverflow,
              a = nt(e, { elementContext: "reference" }),
              s = nt(e, { altBoundary: !0 }),
              u = st(a, n),
              c = st(s, i, o),
              l = ut(u),
              p = ut(c);
            (e.modifiersData[r] = {
              referenceClippingOffsets: u,
              popperEscapeOffsets: c,
              isReferenceHidden: l,
              hasPopperEscaped: p,
            }),
              (e.attributes.popper = Object.assign({}, e.attributes.popper, {
                "data-popper-reference-hidden": l,
                "data-popper-escaped": p,
              }));
          },
        },
      ],
    }),
    lt = function (t, e) {
      return (
        (lt =
          Object.setPrototypeOf ||
          ({ __proto__: [] } instanceof Array &&
            function (t, e) {
              t.__proto__ = e;
            }) ||
          function (t, e) {
            for (var r in e)
              Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
          }),
        lt(t, e)
      );
    };
  function pt(t, e) {
    if ("function" != typeof e && null !== e)
      throw new TypeError(
        "Class extends value " + String(e) + " is not a constructor or null"
      );
    function r() {
      this.constructor = t;
    }
    lt(t, e),
      (t.prototype =
        null === e ? Object.create(e) : ((r.prototype = e.prototype), new r()));
  }
  var ft = function () {
    return (
      (ft =
        Object.assign ||
        function (t) {
          for (var e, r = 1, n = arguments.length; r < n; r++)
            for (var i in (e = arguments[r]))
              Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
          return t;
        }),
      ft.apply(this, arguments)
    );
  };
  function dt(t, e, r, n) {
    return new (r || (r = Promise))(function (i, o) {
      function a(t) {
        try {
          u(n.next(t));
        } catch (t) {
          o(t);
        }
      }
      function s(t) {
        try {
          u(n.throw(t));
        } catch (t) {
          o(t);
        }
      }
      function u(t) {
        var e;
        t.done
          ? i(t.value)
          : ((e = t.value),
            e instanceof r
              ? e
              : new r(function (t) {
                  t(e);
                })).then(a, s);
      }
      u((n = n.apply(t, e || [])).next());
    });
  }
  function ht(t, e) {
    var r,
      n,
      i,
      o,
      a = {
        label: 0,
        sent: function () {
          if (1 & i[0]) throw i[1];
          return i[1];
        },
        trys: [],
        ops: [],
      };
    return (
      (o = { next: s(0), throw: s(1), return: s(2) }),
      "function" == typeof Symbol &&
        (o[Symbol.iterator] = function () {
          return this;
        }),
      o
    );
    function s(o) {
      return function (s) {
        return (function (o) {
          if (r) throw new TypeError("Generator is already executing.");
          for (; a; )
            try {
              if (
                ((r = 1),
                n &&
                  (i =
                    2 & o[0]
                      ? n.return
                      : o[0]
                      ? n.throw || ((i = n.return) && i.call(n), 0)
                      : n.next) &&
                  !(i = i.call(n, o[1])).done)
              )
                return i;
              switch (((n = 0), i && (o = [2 & o[0], i.value]), o[0])) {
                case 0:
                case 1:
                  i = o;
                  break;
                case 4:
                  return a.label++, { value: o[1], done: !1 };
                case 5:
                  a.label++, (n = o[1]), (o = [0]);
                  continue;
                case 7:
                  (o = a.ops.pop()), a.trys.pop();
                  continue;
                default:
                  if (
                    !((i = a.trys),
                    (i = i.length > 0 && i[i.length - 1]) ||
                      (6 !== o[0] && 2 !== o[0]))
                  ) {
                    a = 0;
                    continue;
                  }
                  if (3 === o[0] && (!i || (o[1] > i[0] && o[1] < i[3]))) {
                    a.label = o[1];
                    break;
                  }
                  if (6 === o[0] && a.label < i[1]) {
                    (a.label = i[1]), (i = o);
                    break;
                  }
                  if (i && a.label < i[2]) {
                    (a.label = i[2]), a.ops.push(o);
                    break;
                  }
                  i[2] && a.ops.pop(), a.trys.pop();
                  continue;
              }
              o = e.call(t, a);
            } catch (t) {
              (o = [6, t]), (n = 0);
            } finally {
              r = i = 0;
            }
          if (5 & o[0]) throw o[1];
          return { value: o[0] ? o[1] : void 0, done: !0 };
        })([o, s]);
      };
    }
  }
  function vt(t) {
    var e = "function" == typeof Symbol && Symbol.iterator,
      r = e && t[e],
      n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length)
      return {
        next: function () {
          return (
            t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t }
          );
        },
      };
    throw new TypeError(
      e ? "Object is not iterable." : "Symbol.iterator is not defined."
    );
  }
  function mt(t, e) {
    var r = "function" == typeof Symbol && t[Symbol.iterator];
    if (!r) return t;
    var n,
      i,
      o = r.call(t),
      a = [];
    try {
      for (; (void 0 === e || e-- > 0) && !(n = o.next()).done; )
        a.push(n.value);
    } catch (t) {
      i = { error: t };
    } finally {
      try {
        n && !n.done && (r = o.return) && r.call(o);
      } finally {
        if (i) throw i.error;
      }
    }
    return a;
  }
  function gt(t, e, r) {
    if (r || 2 === arguments.length)
      for (var n, i = 0, o = e.length; i < o; i++)
        (!n && i in e) ||
          (n || (n = Array.prototype.slice.call(e, 0, i)), (n[i] = e[i]));
    return t.concat(n || Array.prototype.slice.call(e));
  }
  var yt = (function () {
      function t() {}
      return (
        (t.prototype.valueOf = function () {}),
        (t.prototype.liquidMethodMissing = function (t) {}),
        t
      );
    })(),
    wt = Object.prototype.toString,
    bt = String.prototype.toLowerCase;
  function _t(t) {
    return "string" == typeof t;
  }
  function St(t) {
    return "function" == typeof t;
  }
  function xt(t) {
    return _t((t = Tt(t))) ? t : qt(t) ? "" : String(t);
  }
  function Tt(t) {
    return t instanceof yt ? t.valueOf() : t;
  }
  function Ot(t) {
    return "number" == typeof t;
  }
  function kt(t) {
    return t && St(t.toLiquid) ? kt(t.toLiquid()) : t;
  }
  function qt(t) {
    return null == t;
  }
  function Et(t) {
    return "[object Array]" === wt.call(t);
  }
  function At(t, e) {
    for (var r in (t = t || {}))
      if (Object.hasOwnProperty.call(t, r) && !1 === e(t[r], r, t)) break;
    return t;
  }
  function Lt(t) {
    return t[t.length - 1];
  }
  function Pt(t) {
    var e = typeof t;
    return null !== t && ("object" === e || "function" === e);
  }
  function Ft(t, e, r) {
    void 0 === r && (r = 1);
    for (var n = [], i = t; i < e; i += r) n.push(i);
    return n;
  }
  function Ct(t, e, r) {
    return (
      void 0 === r && (r = " "),
      Nt(t, e, r, function (t, e) {
        return e + t;
      })
    );
  }
  function Nt(t, e, r, n) {
    for (var i = e - (t = String(t)).length; i-- > 0; ) t = n(t, r);
    return t;
  }
  function jt(t) {
    return t;
  }
  function Rt(t) {
    return t.replace(/(\w?)([A-Z])/g, function (t, e, r) {
      return (e ? e + "_" : "") + r.toLowerCase();
    });
  }
  function Dt(t, e) {
    return null == t && null == e
      ? 0
      : null == t
      ? 1
      : null == e || (t = bt.call(t)) < (e = bt.call(e))
      ? -1
      : t > e
      ? 1
      : 0;
  }
  var Mt = function (t, e, r, n) {
      (this.key = t), (this.value = e), (this.next = r), (this.prev = n);
    },
    It = (function () {
      function t(t, e) {
        void 0 === e && (e = 0),
          (this.limit = t),
          (this.size = e),
          (this.cache = {}),
          (this.head = new Mt("HEAD", null, null, null)),
          (this.tail = new Mt("TAIL", null, null, null)),
          (this.head.next = this.tail),
          (this.tail.prev = this.head);
      }
      return (
        (t.prototype.write = function (t, e) {
          if (this.cache[t]) this.cache[t].value = e;
          else {
            var r = new Mt(t, e, this.head.next, this.head);
            (this.head.next.prev = r),
              (this.head.next = r),
              (this.cache[t] = r),
              this.size++,
              this.ensureLimit();
          }
        }),
        (t.prototype.read = function (t) {
          if (this.cache[t]) {
            var e = this.cache[t].value;
            return this.remove(t), this.write(t, e), e;
          }
        }),
        (t.prototype.remove = function (t) {
          var e = this.cache[t];
          (e.prev.next = e.next),
            (e.next.prev = e.prev),
            delete this.cache[t],
            this.size--;
        }),
        (t.prototype.clear = function () {
          (this.head.next = this.tail),
            (this.tail.prev = this.head),
            (this.size = 0),
            (this.cache = {});
        }),
        (t.prototype.ensureLimit = function () {
          this.size > this.limit && this.remove(this.tail.prev.key);
        }),
        t
      );
    })();
  function Vt(t, e) {
    var r = document.createElement("base");
    r.href = t;
    var n = document.getElementsByTagName("head")[0];
    n.insertBefore(r, n.firstChild);
    var i = document.createElement("a");
    i.href = e;
    var o = i.href;
    return n.removeChild(r), o;
  }
  var Bt = Object.freeze({
    __proto__: null,
    resolve: function (t, e, r) {
      return (
        t.length && "/" !== Lt(t) && (t += "/"),
        Vt(t, e).replace(/^(\w+:\/\/[^/]+)(\/[^?]+)/, function (t, e, n) {
          var i = n.split("/").pop();
          return /\.\w+$/.test(i) ? t : e + n + r;
        })
      );
    },
    readFile: function (t) {
      return dt(this, void 0, void 0, function () {
        return ht(this, function (e) {
          return [
            2,
            new Promise(function (e, r) {
              var n = new XMLHttpRequest();
              (n.onload = function () {
                n.status >= 200 && n.status < 300
                  ? e(n.responseText)
                  : r(new Error(n.statusText));
              }),
                (n.onerror = function () {
                  r(
                    new Error(
                      "An error occurred whilst receiving the response."
                    )
                  );
                }),
                n.open("GET", t),
                n.send();
            }),
          ];
        });
      });
    },
    readFileSync: function (t) {
      var e = new XMLHttpRequest();
      if ((e.open("GET", t, !1), e.send(), e.status < 200 || e.status >= 300))
        throw new Error(e.statusText);
      return e.responseText;
    },
    exists: function (t) {
      return dt(this, void 0, void 0, function () {
        return ht(this, function (t) {
          return [2, !0];
        });
      });
    },
    existsSync: function (t) {
      return !0;
    },
    dirname: function (t) {
      return Vt(t, ".");
    },
    sep: "/",
  });
  function zt(t) {
    return t && St(t.equals);
  }
  function Ht(t, e) {
    return !Wt(t, e);
  }
  function Wt(t, e) {
    return e.opts.jsTruthy ? !t : !1 === t || null == t;
  }
  var Ut = {
      "==": function (t, e) {
        return zt(t) ? t.equals(e) : zt(e) ? e.equals(t) : t === e;
      },
      "!=": function (t, e) {
        return zt(t) ? !t.equals(e) : zt(e) ? !e.equals(t) : t !== e;
      },
      ">": function (t, e) {
        return zt(t) ? t.gt(e) : zt(e) ? e.lt(t) : t > e;
      },
      "<": function (t, e) {
        return zt(t) ? t.lt(e) : zt(e) ? e.gt(t) : t < e;
      },
      ">=": function (t, e) {
        return zt(t) ? t.geq(e) : zt(e) ? e.leq(t) : t >= e;
      },
      "<=": function (t, e) {
        return zt(t) ? t.leq(e) : zt(e) ? e.geq(t) : t <= e;
      },
      contains: function (t, e) {
        return !(!t || !St(t.indexOf)) && t.indexOf(e) > -1;
      },
      and: function (t, e, r) {
        return Ht(t, r) && Ht(e, r);
      },
      or: function (t, e, r) {
        return Ht(t, r) || Ht(e, r);
      },
    },
    Jt = [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 20, 4, 4, 4, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 20, 2, 8, 0, 0, 0, 0, 8, 0, 0, 0, 64, 0, 65, 0, 0,
      33, 33, 33, 33, 33, 33, 33, 33, 33, 33, 0, 0, 2, 2, 2, 1, 0, 1, 1, 1, 1,
      1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0,
      0, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
      1, 1, 1, 1, 0, 0, 0, 0, 0,
    ];
  function Yt(t) {
    var e,
      r,
      n = {};
    try {
      for (var i = vt(Object.entries(t)), o = i.next(); !o.done; o = i.next()) {
        for (
          var a = mt(o.value, 2), s = a[0], u = a[1], c = n, l = 0;
          l < s.length;
          l++
        ) {
          var p = s[l];
          (c[p] = c[p] || {}),
            l === s.length - 1 &&
              1 & Jt[s.charCodeAt(l)] &&
              (c[p].needBoundary = !0),
            (c = c[p]);
        }
        (c.handler = u), (c.end = !0);
      }
    } catch (t) {
      e = { error: t };
    } finally {
      try {
        o && !o.done && (r = i.return) && r.call(i);
      } finally {
        if (e) throw e.error;
      }
    }
    return n;
  }
  Jt[160] =
    Jt[5760] =
    Jt[6158] =
    Jt[8192] =
    Jt[8193] =
    Jt[8194] =
    Jt[8195] =
    Jt[8196] =
    Jt[8197] =
    Jt[8198] =
    Jt[8199] =
    Jt[8200] =
    Jt[8201] =
    Jt[8202] =
    Jt[8232] =
    Jt[8233] =
    Jt[8239] =
    Jt[8287] =
    Jt[12288] =
      4;
  var $t = {
    root: ["."],
    layouts: ["."],
    partials: ["."],
    relativeReference: !0,
    jekyllInclude: !1,
    cache: void 0,
    extname: "",
    fs: Bt,
    dynamicPartials: !0,
    jsTruthy: !1,
    trimTagRight: !1,
    trimTagLeft: !1,
    trimOutputRight: !1,
    trimOutputLeft: !1,
    greedy: !0,
    tagDelimiterLeft: "{%",
    tagDelimiterRight: "%}",
    outputDelimiterLeft: "{{",
    outputDelimiterRight: "}}",
    preserveTimezones: !1,
    strictFilters: !1,
    strictVariables: !1,
    ownPropertyOnly: !1,
    lenientIf: !1,
    globals: {},
    keepOutputType: !1,
    operators: Ut,
    operatorsTrie: Yt(Ut),
  };
  function Gt(t) {
    var e = [];
    return Et(t) && (e = t), _t(t) && (e = [t]), e;
  }
  var Qt = (function (t) {
      function e(e, r) {
        var n = t.call(this, e.message) || this;
        return (n.originalError = e), (n.token = r), (n.context = ""), n;
      }
      return (
        pt(e, t),
        (e.prototype.update = function () {
          var t = this.originalError;
          (this.context = (function (t) {
            var e = mt(t.getPosition(), 1)[0],
              r = t.input.split("\n"),
              n = Math.max(e - 2, 1),
              i = Math.min(e + 3, r.length);
            return Ft(n, i + 1)
              .map(function (t) {
                var n = t === e ? ">> " : "   ",
                  o = Ct(String(t), String(i).length),
                  a = r[t - 1];
                return "".concat(n).concat(o, "| ").concat(a);
              })
              .join("\n");
          })(this.token)),
            (this.message = (function (t, e) {
              e.file && (t += ", file:".concat(e.file));
              var r = mt(e.getPosition(), 2),
                n = r[0],
                i = r[1];
              return (t += ", line:".concat(n, ", col:").concat(i));
            })(t.message, this.token)),
            (this.stack =
              this.message +
              "\n" +
              this.context +
              "\n" +
              this.stack +
              "\nFrom " +
              t.stack);
        }),
        e
      );
    })(Error),
    Xt = (function (t) {
      function e(e, r) {
        var n = t.call(this, new Error(e), r) || this;
        return (n.name = "TokenizationError"), t.prototype.update.call(n), n;
      }
      return pt(e, t), e;
    })(Qt),
    Zt = (function (t) {
      function e(e, r) {
        var n = t.call(this, e, r) || this;
        return (
          (n.name = "ParseError"),
          (n.message = e.message),
          t.prototype.update.call(n),
          n
        );
      }
      return pt(e, t), e;
    })(Qt),
    Kt = (function (t) {
      function e(e, r) {
        var n = t.call(this, e, r.token) || this;
        return (
          (n.name = "RenderError"),
          (n.message = e.message),
          t.prototype.update.call(n),
          n
        );
      }
      return (
        pt(e, t),
        (e.is = function (t) {
          return "RenderError" === t.name;
        }),
        e
      );
    })(Qt),
    te = (function (t) {
      function e(e, r) {
        var n = t.call(this, e, r) || this;
        return (
          (n.name = "UndefinedVariableError"),
          (n.message = e.message),
          t.prototype.update.call(n),
          n
        );
      }
      return pt(e, t), e;
    })(Qt),
    ee = (function (t) {
      function e(e) {
        var r = t.call(this, "undefined variable: ".concat(e)) || this;
        return (
          (r.name = "InternalUndefinedVariableError"), (r.variableName = e), r
        );
      }
      return pt(e, t), e;
    })(Error),
    re = (function (t) {
      function e(e) {
        var r = t.call(this, e) || this;
        return (r.name = "AssertionError"), (r.message = e + ""), r;
      }
      return pt(e, t), e;
    })(Error);
  var ne,
    ie = (function () {
      function t(t, e, r) {
        var n, i;
        void 0 === t && (t = {}),
          void 0 === e && (e = $t),
          void 0 === r && (r = {}),
          (this.scopes = [{}]),
          (this.registers = {}),
          (this.sync = !!r.sync),
          (this.opts = e),
          (this.globals =
            null !== (n = r.globals) && void 0 !== n ? n : e.globals),
          (this.environments = t),
          (this.strictVariables =
            null !== (i = r.strictVariables) && void 0 !== i
              ? i
              : this.opts.strictVariables);
      }
      return (
        (t.prototype.getRegister = function (t) {
          return (this.registers[t] = this.registers[t] || {});
        }),
        (t.prototype.setRegister = function (t, e) {
          return (this.registers[t] = e);
        }),
        (t.prototype.saveRegister = function () {
          for (var t = this, e = [], r = 0; r < arguments.length; r++)
            e[r] = arguments[r];
          return e.map(function (e) {
            return [e, t.getRegister(e)];
          });
        }),
        (t.prototype.restoreRegister = function (t) {
          var e = this;
          return t.forEach(function (t) {
            var r = mt(t, 2),
              n = r[0],
              i = r[1];
            return e.setRegister(n, i);
          });
        }),
        (t.prototype.getAll = function () {
          return gt(
            [this.globals, this.environments],
            mt(this.scopes),
            !1
          ).reduce(function (t, e) {
            return ft(t, e);
          }, {});
        }),
        (t.prototype.get = function (t) {
          var e = this.findScope(t[0]);
          return this.getFromScope(e, t);
        }),
        (t.prototype.getFromScope = function (t, e) {
          var r = this;
          return (
            _t(e) && (e = e.split(".")),
            e.reduce(function (t, n, i) {
              if (
                ((t = (function (t, e, r) {
                  if (qt(t)) return t;
                  var n = (function (t, e, r) {
                    return r && !Object.hasOwnProperty.call(t, e)
                      ? void 0
                      : t[e];
                  })((t = kt(t)), e, r);
                  if (St(n)) return n.call(t);
                  if (t instanceof yt)
                    return t.hasOwnProperty(e)
                      ? t[e]
                      : t.liquidMethodMissing(e);
                  return "size" === e
                    ? (function (t) {
                        if (t.hasOwnProperty("size") || void 0 !== t.size)
                          return t.size;
                        if (Et(t) || _t(t)) return t.length;
                        if ("object" == typeof t) return Object.keys(t).length;
                      })(t)
                    : "first" === e
                    ? (function (t) {
                        return Et(t) ? t[0] : t.first;
                      })(t)
                    : "last" === e
                    ? (function (t) {
                        return Et(t) ? t[t.length - 1] : t.last;
                      })(t)
                    : n;
                })(t, n, r.opts.ownPropertyOnly)),
                qt(t) && r.strictVariables)
              )
                throw new ee(e.slice(0, i + 1).join("."));
              return t;
            }, t)
          );
        }),
        (t.prototype.push = function (t) {
          return this.scopes.push(t);
        }),
        (t.prototype.pop = function () {
          return this.scopes.pop();
        }),
        (t.prototype.bottom = function () {
          return this.scopes[0];
        }),
        (t.prototype.findScope = function (t) {
          for (var e = this.scopes.length - 1; e >= 0; e--) {
            var r = this.scopes[e];
            if (t in r) return r;
          }
          return t in this.environments ? this.environments : this.globals;
        }),
        t
      );
    })();
  function oe(t, e) {
    if (!t) {
      var r =
        "function" == typeof e ? e() : e || "expect ".concat(t, " to be true");
      throw new re(r);
    }
  }
  !(function (t) {
    (t.Partials = "partials"), (t.Layouts = "layouts"), (t.Root = "root");
  })(ne || (ne = {}));
  var ae = (function () {
      function t(t) {
        if (((this.options = t), t.relativeReference)) {
          var e = t.fs.sep;
          oe(e, "`fs.sep` is required for relative reference");
          var r = new RegExp(
            ["." + e, ".." + e, "./", "../"]
              .map(function (t) {
                return t.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
              })
              .join("|")
          );
          this.shouldLoadRelative = function (t) {
            return r.test(t);
          };
        } else
          this.shouldLoadRelative = function (t) {
            return !1;
          };
        this.contains =
          this.options.fs.contains ||
          function () {
            return !0;
          };
      }
      return (
        (t.prototype.lookup = function (t, e, r, n) {
          var i, o, a, s, u, c, l, p, f;
          return ht(this, function (d) {
            switch (d.label) {
              case 0:
                (i = this.options.fs), (o = this.options[e]), (d.label = 1);
              case 1:
                d.trys.push([1, 8, 9, 10]),
                  (a = vt(this.candidates(t, o, n, e !== ne.Root))),
                  (s = a.next()),
                  (d.label = 2);
              case 2:
                return s.done
                  ? [3, 7]
                  : ((u = s.value),
                    r ? ((c = i.existsSync(u)), [3, 5]) : [3, 3]);
              case 3:
                return [4, i.exists(u)];
              case 4:
                (c = d.sent()), (d.label = 5);
              case 5:
                if (c) return [2, u];
                d.label = 6;
              case 6:
                return (s = a.next()), [3, 2];
              case 7:
                return [3, 10];
              case 8:
                return (l = d.sent()), (p = { error: l }), [3, 10];
              case 9:
                try {
                  s && !s.done && (f = a.return) && f.call(a);
                } finally {
                  if (p) throw p.error;
                }
                return [7];
              case 10:
                throw this.lookupError(t, o);
            }
          });
        }),
        (t.prototype.candidates = function (t, e, r, n) {
          var i, o, a, s, u, c, l, p, f, d, h, v, m, g, y, w;
          return ht(this, function (b) {
            switch (b.label) {
              case 0:
                if (
                  ((i = this.options),
                  (o = i.fs),
                  (a = i.extname),
                  !this.shouldLoadRelative(t) || !r)
                )
                  return [3, 8];
                (d = o.resolve(this.dirname(r), t, a)), (b.label = 1);
              case 1:
                b.trys.push([1, 6, 7, 8]),
                  (s = vt(e)),
                  (u = s.next()),
                  (b.label = 2);
              case 2:
                return u.done
                  ? [3, 5]
                  : ((f = u.value),
                    n && !this.contains(f, d) ? [3, 4] : [4, d]);
              case 3:
                return b.sent(), [3, 5];
              case 4:
                return (u = s.next()), [3, 2];
              case 5:
                return [3, 8];
              case 6:
                return (c = b.sent()), (m = { error: c }), [3, 8];
              case 7:
                try {
                  u && !u.done && (g = s.return) && g.call(s);
                } finally {
                  if (m) throw m.error;
                }
                return [7];
              case 8:
                b.trys.push([8, 13, 14, 15]),
                  (l = vt(e)),
                  (p = l.next()),
                  (b.label = 9);
              case 9:
                return p.done
                  ? [3, 12]
                  : ((f = p.value),
                    (d = o.resolve(f, t, a)),
                    n && !this.contains(f, d) ? [3, 11] : [4, d]);
              case 10:
                b.sent(), (b.label = 11);
              case 11:
                return (p = l.next()), [3, 9];
              case 12:
                return [3, 15];
              case 13:
                return (h = b.sent()), (y = { error: h }), [3, 15];
              case 14:
                try {
                  p && !p.done && (w = l.return) && w.call(l);
                } finally {
                  if (y) throw y.error;
                }
                return [7];
              case 15:
                return void 0 === o.fallback || void 0 === (v = o.fallback(t))
                  ? [3, 17]
                  : [4, v];
              case 16:
                b.sent(), (b.label = 17);
              case 17:
                return [2];
            }
          });
        }),
        (t.prototype.dirname = function (t) {
          var e = this.options.fs;
          return (
            oe(e.dirname, "`fs.dirname` is required for relative reference"),
            e.dirname(t)
          );
        }),
        (t.prototype.lookupError = function (t, e) {
          var r = new Error("ENOENT");
          return (
            (r.message = 'ENOENT: Failed to lookup "'
              .concat(t, '" in "')
              .concat(e, '"')),
            (r.code = "ENOENT"),
            r
          );
        }),
        t
      );
    })(),
    se = (function () {
      function t() {
        this.buffer = "";
      }
      return (
        (t.prototype.write = function (t) {
          this.buffer += xt(t);
        }),
        t
      );
    })(),
    ue = function () {
      throw (
        ((this.buffer = ""),
        (this.stream = null),
        new Error("streaming not supported in browser"))
      );
    };
  function ce(t) {
    var e = {
      then: function (e) {
        return e(t);
      },
      catch: function () {
        return e;
      },
    };
    return e;
  }
  function le(t) {
    var e = {
      then: function (r, n) {
        return n ? n(t) : e;
      },
      catch: function (e) {
        return e(t);
      },
    };
    return e;
  }
  function pe(t) {
    return (function (t) {
      return t && St(t.then);
    })(t)
      ? t
      : (function (t) {
          return t && St(t.next) && St(t.throw) && St(t.return);
        })(t)
      ? (function e(r) {
          var n;
          try {
            n = t.next(r);
          } catch (t) {
            return le(t);
          }
          return n.done
            ? ce(n.value)
            : pe(n.value).then(e, function (r) {
                var n;
                try {
                  n = t.throw(r);
                } catch (t) {
                  return le(t);
                }
                return n.done ? ce(n.value) : e(n.value);
              });
        })()
      : ce(t);
  }
  function fe(t) {
    return Promise.resolve(pe(t));
  }
  function de(t) {
    var e;
    return (
      pe(t)
        .then(function (t) {
          return ce((e = t));
        })
        .catch(function (t) {
          throw t;
        }),
      e
    );
  }
  var he,
    ve = (function () {
      function t() {
        this.buffer = "";
      }
      return (
        (t.prototype.write = function (t) {
          "string" != typeof (t = Tt(t)) && "" === this.buffer
            ? (this.buffer = t)
            : (this.buffer = xt(this.buffer) + xt(t));
        }),
        t
      );
    })(),
    me = (function () {
      function t() {}
      return (
        (t.prototype.renderTemplatesToNodeStream = function (t, e) {
          var r = this,
            n = new ue();
          return (
            Promise.resolve()
              .then(function () {
                return pe(r.renderTemplates(t, e, n));
              })
              .then(
                function () {
                  return n.end();
                },
                function (t) {
                  return n.error(t);
                }
              ),
            n.stream
          );
        }),
        (t.prototype.renderTemplates = function (t, e, r) {
          var n, i, o, a, s, u, c, l;
          return ht(this, function (p) {
            switch (p.label) {
              case 0:
                r || (r = e.opts.keepOutputType ? new ve() : new se()),
                  (p.label = 1);
              case 1:
                p.trys.push([1, 8, 9, 10]),
                  (n = vt(t)),
                  (i = n.next()),
                  (p.label = 2);
              case 2:
                if (i.done) return [3, 7];
                (o = i.value), (p.label = 3);
              case 3:
                return p.trys.push([3, 5, , 6]), [4, o.render(e, r)];
              case 4:
                return (
                  (a = p.sent()) && r.write(a),
                  r.break || r.continue ? [3, 7] : [3, 6]
                );
              case 5:
                throw ((s = p.sent()), Kt.is(s) ? s : new Kt(s, o));
              case 6:
                return (i = n.next()), [3, 2];
              case 7:
                return [3, 10];
              case 8:
                return (u = p.sent()), (c = { error: u }), [3, 10];
              case 9:
                try {
                  i && !i.done && (l = n.return) && l.call(n);
                } finally {
                  if (c) throw c.error;
                }
                return [7];
              case 10:
                return [2, r.buffer];
            }
          });
        }),
        t
      );
    })();
  function ge(t) {
    return !!(Ee(t) & he.Delimited);
  }
  function ye(t) {
    return Ee(t) === he.Operator;
  }
  function we(t) {
    return Ee(t) === he.HTML;
  }
  function be(t) {
    return Ee(t) === he.Output;
  }
  function _e(t) {
    return Ee(t) === he.Tag;
  }
  function Se(t) {
    return Ee(t) === he.Quoted;
  }
  function xe(t) {
    return Ee(t) === he.Literal;
  }
  function Te(t) {
    return Ee(t) === he.Number;
  }
  function Oe(t) {
    return Ee(t) === he.PropertyAccess;
  }
  function ke(t) {
    return Ee(t) === he.Word;
  }
  function qe(t) {
    return Ee(t) === he.Range;
  }
  function Ee(t) {
    return t ? t.kind : -1;
  }
  !(function (t) {
    (t[(t.Number = 1)] = "Number"),
      (t[(t.Literal = 2)] = "Literal"),
      (t[(t.Tag = 4)] = "Tag"),
      (t[(t.Output = 8)] = "Output"),
      (t[(t.HTML = 16)] = "HTML"),
      (t[(t.Filter = 32)] = "Filter"),
      (t[(t.Hash = 64)] = "Hash"),
      (t[(t.PropertyAccess = 128)] = "PropertyAccess"),
      (t[(t.Word = 256)] = "Word"),
      (t[(t.Range = 512)] = "Range"),
      (t[(t.Quoted = 1024)] = "Quoted"),
      (t[(t.Operator = 2048)] = "Operator"),
      (t[(t.Delimited = 12)] = "Delimited");
  })(he || (he = {}));
  var Ae = (function () {
      function t(t, e) {
        (this.handlers = {}),
          (this.stopRequested = !1),
          (this.tokens = t),
          (this.parseToken = e);
      }
      return (
        (t.prototype.on = function (t, e) {
          return (this.handlers[t] = e), this;
        }),
        (t.prototype.trigger = function (t, e) {
          var r = this.handlers[t];
          return !!r && (r.call(this, e), !0);
        }),
        (t.prototype.start = function () {
          var t;
          for (
            this.trigger("start");
            !this.stopRequested && (t = this.tokens.shift());

          )
            if (
              !(
                this.trigger("token", t) ||
                (_e(t) && this.trigger("tag:".concat(t.name), t))
              )
            ) {
              var e = this.parseToken(t, this.tokens);
              this.trigger("template", e);
            }
          return this.stopRequested || this.trigger("end"), this;
        }),
        (t.prototype.stop = function () {
          return (this.stopRequested = !0), this;
        }),
        t
      );
    })(),
    Le = function (t) {
      this.token = t;
    },
    Pe = (function (t) {
      function e() {
        return (null !== t && t.apply(this, arguments)) || this;
      }
      return (
        pt(e, t),
        (e.prototype.equals = function (t) {
          return qt(Tt(t));
        }),
        (e.prototype.gt = function () {
          return !1;
        }),
        (e.prototype.geq = function () {
          return !1;
        }),
        (e.prototype.lt = function () {
          return !1;
        }),
        (e.prototype.leq = function () {
          return !1;
        }),
        (e.prototype.valueOf = function () {
          return null;
        }),
        e
      );
    })(yt),
    Fe = (function (t) {
      function e() {
        return (null !== t && t.apply(this, arguments)) || this;
      }
      return (
        pt(e, t),
        (e.prototype.equals = function (t) {
          return (
            !(t instanceof e) &&
            (_t((t = Tt(t))) || Et(t)
              ? 0 === t.length
              : !!Pt(t) && 0 === Object.keys(t).length)
          );
        }),
        (e.prototype.gt = function () {
          return !1;
        }),
        (e.prototype.geq = function () {
          return !1;
        }),
        (e.prototype.lt = function () {
          return !1;
        }),
        (e.prototype.leq = function () {
          return !1;
        }),
        (e.prototype.valueOf = function () {
          return "";
        }),
        e
      );
    })(yt),
    Ce = (function (t) {
      function e() {
        return (null !== t && t.apply(this, arguments)) || this;
      }
      return (
        pt(e, t),
        (e.prototype.equals = function (e) {
          return (
            !1 === e ||
            !!qt(Tt(e)) ||
            (_t(e) ? /^\s*$/.test(e) : t.prototype.equals.call(this, e))
          );
        }),
        e
      );
    })(Fe),
    Ne = new Pe(),
    je = {
      true: !0,
      false: !1,
      nil: Ne,
      null: Ne,
      empty: new Fe(),
      blank: new Ce(),
    },
    Re = /[\da-fA-F]/,
    De = /[0-7]/,
    Me = { b: "\b", f: "\f", n: "\n", r: "\r", t: "\t", v: "\v" };
  function Ie(t) {
    var e = t.charCodeAt(0);
    return e >= 97 ? e - 87 : e >= 65 ? e - 55 : e - 48;
  }
  function Ve(t) {
    for (var e = "", r = 1; r < t.length - 1; r++)
      if ("\\" === t[r])
        if (void 0 !== Me[t[r + 1]]) e += Me[t[++r]];
        else if ("u" === t[r + 1]) {
          for (var n = 0, i = r + 2; i <= r + 5 && Re.test(t[i]); )
            n = 16 * n + Ie(t[i++]);
          (r = i - 1), (e += String.fromCharCode(n));
        } else if (De.test(t[r + 1])) {
          for (i = r + 1, n = 0; i <= r + 3 && De.test(t[i]); )
            n = 8 * n + Ie(t[i++]);
          (r = i - 1), (e += String.fromCharCode(n));
        } else e += t[++r];
      else e += t[r];
    return e;
  }
  var Be = (function () {
    function t(t) {
      this.postfix = gt(
        [],
        mt(
          (function (t) {
            var e, r, n, i, o, a, s;
            return ht(this, function (u) {
              switch (u.label) {
                case 0:
                  (e = []), (u.label = 1);
                case 1:
                  u.trys.push([1, 10, 11, 12]),
                    (r = vt(t)),
                    (n = r.next()),
                    (u.label = 2);
                case 2:
                  if (n.done) return [3, 9];
                  if (!ye((i = n.value))) return [3, 6];
                  u.label = 3;
                case 3:
                  return e.length &&
                    e[e.length - 1].getPrecedence() > i.getPrecedence()
                    ? [4, e.pop()]
                    : [3, 5];
                case 4:
                  return u.sent(), [3, 3];
                case 5:
                  return e.push(i), [3, 8];
                case 6:
                  return [4, i];
                case 7:
                  u.sent(), (u.label = 8);
                case 8:
                  return (n = r.next()), [3, 2];
                case 9:
                  return [3, 12];
                case 10:
                  return (o = u.sent()), (a = { error: o }), [3, 12];
                case 11:
                  try {
                    n && !n.done && (s = r.return) && s.call(r);
                  } finally {
                    if (a) throw a.error;
                  }
                  return [7];
                case 12:
                  return e.length ? [4, e.pop()] : [3, 14];
                case 13:
                  return u.sent(), [3, 12];
                case 14:
                  return [2];
              }
            });
          })(t)
        ),
        !1
      );
    }
    return (
      (t.prototype.evaluate = function (t, e) {
        var r, n, i, o, a, s, u, c, l, p, f, d;
        return ht(this, function (h) {
          switch (h.label) {
            case 0:
              oe(t, "unable to evaluate: context not defined"),
                (r = []),
                (h.label = 1);
            case 1:
              h.trys.push([1, 9, 10, 11]),
                (n = vt(this.postfix)),
                (i = n.next()),
                (h.label = 2);
            case 2:
              return i.done
                ? [3, 8]
                : ye((o = i.value))
                ? [4, r.pop()]
                : [3, 5];
            case 3:
              return (a = h.sent()), [4, r.pop()];
            case 4:
              return (
                (s = h.sent()),
                (u = (function (t, e, r, n, i) {
                  return (0, t[e.operator])(r, n, i);
                })(t.opts.operators, o, s, a, t)),
                r.push(u),
                [3, 7]
              );
            case 5:
              return (
                (l = (c = r).push),
                [4, ze(o, t, e && 1 === this.postfix.length)]
              );
            case 6:
              l.apply(c, [h.sent()]), (h.label = 7);
            case 7:
              return (i = n.next()), [3, 2];
            case 8:
              return [3, 11];
            case 9:
              return (p = h.sent()), (f = { error: p }), [3, 11];
            case 10:
              try {
                i && !i.done && (d = n.return) && d.call(n);
              } finally {
                if (f) throw f.error;
              }
              return [7];
            case 11:
              return [2, r[0]];
          }
        });
      }),
      t
    );
  })();
  function ze(t, e, r) {
    return (
      void 0 === r && (r = !1),
      Oe(t)
        ? (function (t, e, r) {
            var n = t.props.map(function (t) {
              return ze(t, e, !1);
            });
            try {
              return e.get(gt([t.propertyName], mt(n), !1));
            } catch (e) {
              if (r && "InternalUndefinedVariableError" === e.name) return null;
              throw new te(e, t);
            }
          })(t, e, r)
        : qe(t)
        ? (function (t, e) {
            var r = ze(t.lhs, e),
              n = ze(t.rhs, e);
            return Ft(+r, +n + 1);
          })(t, e)
        : xe(t)
        ? (function (t) {
            return je[t.literal];
          })(t)
        : Te(t)
        ? (function (t) {
            var e =
              t.whole.content + "." + (t.decimal ? t.decimal.content : "");
            return Number(e);
          })(t)
        : ke(t)
        ? t.getText()
        : Se(t)
        ? He(t)
        : void 0
    );
  }
  function He(t) {
    return Ve(t.getText());
  }
  var We = (function () {
      function t(t, e, r, n, i) {
        (this.kind = t),
          (this.input = e),
          (this.begin = r),
          (this.end = n),
          (this.file = i);
      }
      return (
        (t.prototype.getText = function () {
          return this.input.slice(this.begin, this.end);
        }),
        (t.prototype.getPosition = function () {
          for (
            var t = mt([1, 1], 2), e = t[0], r = t[1], n = 0;
            n < this.begin;
            n++
          )
            "\n" === this.input[n] ? (e++, (r = 1)) : r++;
          return [e, r];
        }),
        (t.prototype.size = function () {
          return this.end - this.begin;
        }),
        t
      );
    })(),
    Ue = (function (t) {
      function e(e, r, n, i, o, a, s, u) {
        var c = t.call(this, e, n, i, o, u) || this;
        (c.trimLeft = !1), (c.trimRight = !1), (c.content = c.getText());
        var l = "-" === r[0],
          p = "-" === Lt(r);
        return (
          (c.content = r.slice(l ? 1 : 0, p ? -1 : r.length).trim()),
          (c.trimLeft = l || a),
          (c.trimRight = p || s),
          c
        );
      }
      return pt(e, t), e;
    })(We);
  function Je(t, e) {
    if (t && we(t))
      for (
        var r = e ? 4 : 16;
        Jt[t.input.charCodeAt(t.end - 1 - t.trimRight)] & r;

      )
        t.trimRight++;
  }
  function Ye(t, e) {
    if (t && we(t)) {
      for (
        var r = e ? 4 : 16;
        Jt[t.input.charCodeAt(t.begin + t.trimLeft)] & r;

      )
        t.trimLeft++;
      "\n" === t.input.charAt(t.begin + t.trimLeft) && t.trimLeft++;
    }
  }
  var $e = (function (t) {
      function e(e, r) {
        var n =
          t.call(
            this,
            he.Number,
            e.input,
            e.begin,
            r ? r.end : e.end,
            e.file
          ) || this;
        return (n.whole = e), (n.decimal = r), n;
      }
      return pt(e, t), e;
    })(We),
    Ge = (function (t) {
      function e(e, r, n, i) {
        var o = t.call(this, he.Word, e, r, n, i) || this;
        return (
          (o.input = e),
          (o.begin = r),
          (o.end = n),
          (o.file = i),
          (o.content = o.getText()),
          o
        );
      }
      return (
        pt(e, t),
        (e.prototype.isNumber = function (t) {
          void 0 === t && (t = !1);
          for (
            var e =
              t && 64 & Jt[this.input.charCodeAt(this.begin)]
                ? this.begin + 1
                : this.begin;
            e < this.end;
            e++
          )
            if (!(32 & Jt[this.input.charCodeAt(e)])) return !1;
          return !0;
        }),
        e
      );
    })(We),
    Qe = (function (t) {
      function e(e, r, n, i) {
        var o = t.call(this, he.Literal, e, r, n, i) || this;
        return (
          (o.input = e),
          (o.begin = r),
          (o.end = n),
          (o.file = i),
          (o.literal = o.getText()),
          o
        );
      }
      return pt(e, t), e;
    })(We),
    Xe = {
      "==": 1,
      "!=": 1,
      ">": 1,
      "<": 1,
      ">=": 1,
      "<=": 1,
      contains: 1,
      and: 0,
      or: 0,
    },
    Ze = (function (t) {
      function e(e, r, n, i) {
        var o = t.call(this, he.Operator, e, r, n, i) || this;
        return (
          (o.input = e),
          (o.begin = r),
          (o.end = n),
          (o.file = i),
          (o.operator = o.getText()),
          o
        );
      }
      return (
        pt(e, t),
        (e.prototype.getPrecedence = function () {
          var t = this.getText();
          return t in Xe ? Xe[t] : 1;
        }),
        e
      );
    })(We),
    Ke = (function (t) {
      function e(e, r, n) {
        var i =
          t.call(this, he.PropertyAccess, e.input, e.begin, n, e.file) || this;
        return (
          (i.variable = e),
          (i.props = r),
          (i.propertyName =
            i.variable instanceof Ge
              ? i.variable.getText()
              : Ve(i.variable.getText())),
          i
        );
      }
      return pt(e, t), e;
    })(We),
    tr = (function (t) {
      function e(e, r, n, i, o, a) {
        var s = t.call(this, he.Filter, n, i, o, a) || this;
        return (s.name = e), (s.args = r), s;
      }
      return pt(e, t), e;
    })(We),
    er = (function (t) {
      function e(e, r, n, i, o, a) {
        var s = t.call(this, he.Hash, e, r, n, a) || this;
        return (
          (s.input = e),
          (s.begin = r),
          (s.end = n),
          (s.name = i),
          (s.value = o),
          (s.file = a),
          s
        );
      }
      return pt(e, t), e;
    })(We),
    rr = (function (t) {
      function e(e, r, n, i) {
        var o = t.call(this, he.Quoted, e, r, n, i) || this;
        return (o.input = e), (o.begin = r), (o.end = n), (o.file = i), o;
      }
      return pt(e, t), e;
    })(We),
    nr = (function (t) {
      function e(e, r, n, i) {
        var o = t.call(this, he.HTML, e, r, n, i) || this;
        return (
          (o.input = e),
          (o.begin = r),
          (o.end = n),
          (o.file = i),
          (o.trimLeft = 0),
          (o.trimRight = 0),
          o
        );
      }
      return (
        pt(e, t),
        (e.prototype.getContent = function () {
          return this.input.slice(
            this.begin + this.trimLeft,
            this.end - this.trimRight
          );
        }),
        e
      );
    })(We),
    ir = (function (t) {
      function e(e, r, n, i, o, a) {
        var s = t.call(this, he.Range, e, r, n, a) || this;
        return (
          (s.input = e),
          (s.begin = r),
          (s.end = n),
          (s.lhs = i),
          (s.rhs = o),
          (s.file = a),
          s
        );
      }
      return pt(e, t), e;
    })(We),
    or = (function (t) {
      function e(e, r, n, i, o) {
        var a = i.trimOutputLeft,
          s = i.trimOutputRight,
          u = i.outputDelimiterLeft,
          c = i.outputDelimiterRight,
          l = e.slice(r + u.length, n - c.length);
        return t.call(this, he.Output, l, e, r, n, a, s, o) || this;
      }
      return pt(e, t), e;
    })(Ue);
  var ar = (function (t) {
      function e(e, r, n, i, o) {
        var a = this,
          s = e.slice(r, n);
        if (
          ((a = t.call(this, he.Tag, s, e, r, n, !1, !1, o) || this),
          /\S/.test(s))
        ) {
          var u = new sr(a.content, i.operatorsTrie);
          if (((a.name = u.readIdentifier().getText()), !a.name))
            throw new Xt("illegal liquid tag syntax", a);
          u.skipBlank(), (a.args = u.remaining());
        } else (a.name = ""), (a.args = "");
        return a;
      }
      return pt(e, t), e;
    })(Ue),
    sr = (function () {
      function t(t, e, r) {
        void 0 === r && (r = ""),
          (this.input = t),
          (this.trie = e),
          (this.file = r),
          (this.p = 0),
          (this.rawBeginAt = -1),
          (this.N = t.length);
      }
      return (
        (t.prototype.readExpression = function () {
          return new Be(this.readExpressionTokens());
        }),
        (t.prototype.readExpressionTokens = function () {
          var t, e, r;
          return ht(this, function (n) {
            switch (n.label) {
              case 0:
                return (t = this.readValue()) ? [4, t] : [2];
              case 1:
                n.sent(), (n.label = 2);
              case 2:
                return this.p < this.N
                  ? (e = this.readOperator()) && (r = this.readValue())
                    ? [4, e]
                    : [2]
                  : [3, 5];
              case 3:
                return n.sent(), [4, r];
              case 4:
                return n.sent(), [3, 2];
              case 5:
                return [2];
            }
          });
        }),
        (t.prototype.readOperator = function () {
          this.skipBlank();
          var t = (function (t, e, r, n) {
            void 0 === n && (n = t.length);
            for (var i, o = r, a = e; o[t[a]] && a < n; )
              (o = o[t[a++]]).end && (i = o);
            return i
              ? i.needBoundary && 1 & Jt[t.charCodeAt(a)]
                ? -1
                : a
              : -1;
          })(this.input, this.p, this.trie);
          if (-1 !== t)
            return new Ze(this.input, this.p, (this.p = t), this.file);
        }),
        (t.prototype.readFilters = function () {
          for (var t = []; ; ) {
            var e = this.readFilter();
            if (!e) return t;
            t.push(e);
          }
        }),
        (t.prototype.readFilter = function () {
          var t = this;
          if ((this.skipBlank(), this.end())) return null;
          oe("|" === this.peek(), function () {
            return "unexpected token at ".concat(t.snapshot());
          }),
            this.p++;
          var e = this.p,
            r = this.readIdentifier();
          if (!r.size()) return null;
          var n = [];
          if ((this.skipBlank(), ":" === this.peek()))
            do {
              ++this.p;
              var i = this.readFilterArg();
              for (
                i && n.push(i);
                this.p < this.N && "," !== this.peek() && "|" !== this.peek();

              )
                ++this.p;
            } while ("," === this.peek());
          return new tr(r.getText(), n, this.input, e, this.p, this.file);
        }),
        (t.prototype.readFilterArg = function () {
          var t = this.readValue();
          if (t) {
            if ((this.skipBlank(), ":" !== this.peek())) return t;
            ++this.p;
            var e = this.readValue();
            return [t.getText(), e];
          }
        }),
        (t.prototype.readTopLevelTokens = function (t) {
          void 0 === t && (t = $t);
          for (var e = []; this.p < this.N; ) {
            var r = this.readTopLevelToken(t);
            e.push(r);
          }
          return (
            (function (t, e) {
              for (var r = !1, n = 0; n < t.length; n++) {
                var i = t[n];
                ge(i) &&
                  (!r && i.trimLeft && Je(t[n - 1], e.greedy),
                  _e(i) &&
                    ("raw" === i.name
                      ? (r = !0)
                      : "endraw" === i.name && (r = !1)),
                  !r && i.trimRight && Ye(t[n + 1], e.greedy));
              }
            })(e, t),
            e
          );
        }),
        (t.prototype.readTopLevelToken = function (t) {
          var e = t.tagDelimiterLeft,
            r = t.outputDelimiterLeft;
          return this.rawBeginAt > -1
            ? this.readEndrawOrRawContent(t)
            : this.match(e)
            ? this.readTagToken(t)
            : this.match(r)
            ? this.readOutputToken(t)
            : this.readHTMLToken([e, r]);
        }),
        (t.prototype.readHTMLToken = function (t) {
          for (
            var e = this, r = this.p;
            this.p < this.N &&
            !t.some(function (t) {
              return e.match(t);
            });

          )
            ++this.p;
          return new nr(this.input, r, this.p, this.file);
        }),
        (t.prototype.readTagToken = function (t) {
          void 0 === t && (t = $t);
          var e = this.file,
            r = this.input,
            n = this.p;
          if (-1 === this.readToDelimiter(t.tagDelimiterRight))
            throw this.mkError(
              "tag ".concat(this.snapshot(n), " not closed"),
              n
            );
          var i = new ur(r, n, this.p, t, e);
          return "raw" === i.name && (this.rawBeginAt = n), i;
        }),
        (t.prototype.readToDelimiter = function (t) {
          for (; this.p < this.N; )
            if (8 & this.peekType()) this.readQuoted();
            else if ((++this.p, this.rmatch(t))) return this.p;
          return -1;
        }),
        (t.prototype.readOutputToken = function (t) {
          void 0 === t && (t = $t);
          var e = this.file,
            r = this.input,
            n = t.outputDelimiterRight,
            i = this.p;
          if (-1 === this.readToDelimiter(n))
            throw this.mkError(
              "output ".concat(this.snapshot(i), " not closed"),
              i
            );
          return new or(r, i, this.p, t, e);
        }),
        (t.prototype.readEndrawOrRawContent = function (t) {
          for (
            var e = t.tagDelimiterLeft,
              r = t.tagDelimiterRight,
              n = this.p,
              i = this.readTo(e) - e.length;
            this.p < this.N;

          )
            if ("endraw" === this.readIdentifier().getText())
              for (; this.p <= this.N; ) {
                if (this.rmatch(r)) {
                  var o = this.p;
                  return n === i
                    ? ((this.rawBeginAt = -1),
                      new ur(this.input, n, o, t, this.file))
                    : ((this.p = i), new nr(this.input, n, i, this.file));
                }
                if (this.rmatch(e)) break;
                this.p++;
              }
            else i = this.readTo(e) - e.length;
          throw this.mkError(
            "raw ".concat(this.snapshot(this.rawBeginAt), " not closed"),
            n
          );
        }),
        (t.prototype.readLiquidTagTokens = function (t) {
          void 0 === t && (t = $t);
          for (var e = []; this.p < this.N; ) {
            var r = this.readLiquidTagToken(t);
            r.name && e.push(r);
          }
          return e;
        }),
        (t.prototype.readLiquidTagToken = function (t) {
          var e = this.file,
            r = this.input,
            n = this.p,
            i = this.N;
          return (
            -1 !== this.readToDelimiter("\n") && (i = this.p),
            new ar(r, n, i, t, e)
          );
        }),
        (t.prototype.mkError = function (t, e) {
          return new Xt(t, new Ge(this.input, e, this.N, this.file));
        }),
        (t.prototype.snapshot = function (t) {
          return (
            void 0 === t && (t = this.p),
            JSON.stringify(
              ((e = this.input.slice(t)),
              (r = 16),
              e.length > r ? e.substr(0, r - 3) + "..." : e)
            )
          );
          var e, r;
        }),
        (t.prototype.readWord = function () {
          return (
            console.warn(
              "Tokenizer#readWord() will be removed, use #readIdentifier instead"
            ),
            this.readIdentifier()
          );
        }),
        (t.prototype.readIdentifier = function () {
          this.skipBlank();
          for (var t = this.p; 1 & this.peekType(); ) ++this.p;
          return new Ge(this.input, t, this.p, this.file);
        }),
        (t.prototype.readHashes = function (t) {
          for (var e = []; ; ) {
            var r = this.readHash(t);
            if (!r) return e;
            e.push(r);
          }
        }),
        (t.prototype.readHash = function (t) {
          this.skipBlank(), "," === this.peek() && ++this.p;
          var e = this.p,
            r = this.readIdentifier();
          if (r.size()) {
            var n;
            this.skipBlank();
            var i = t ? "=" : ":";
            return (
              this.peek() === i && (++this.p, (n = this.readValue())),
              new er(this.input, e, this.p, r, n, this.file)
            );
          }
        }),
        (t.prototype.remaining = function () {
          return this.input.slice(this.p);
        }),
        (t.prototype.advance = function (t) {
          void 0 === t && (t = 1), (this.p += t);
        }),
        (t.prototype.end = function () {
          return this.p >= this.N;
        }),
        (t.prototype.readTo = function (t) {
          for (; this.p < this.N; )
            if ((++this.p, this.rmatch(t))) return this.p;
          return -1;
        }),
        (t.prototype.readValue = function () {
          var t = this.readQuoted() || this.readRange();
          if (t) return t;
          if ("[" === this.peek()) {
            if ((this.p++, !(i = this.readQuoted()))) return;
            if ("]" !== this.peek()) return;
            return this.p++, new Ke(i, [], this.p);
          }
          var e = this.readIdentifier();
          if (e.size()) {
            for (var r = e.isNumber(!0), n = []; ; )
              if ("[" === this.peek()) {
                (r = !1), this.p++;
                var i =
                  this.readValue() ||
                  new Ge(this.input, this.p, this.p, this.file);
                this.readTo("]"), n.push(i);
              } else {
                if ("." !== this.peek() || "." === this.peek(1)) break;
                if ((this.p++, !(i = this.readIdentifier()).size())) break;
                i.isNumber() || (r = !1), n.push(i);
              }
            return !n.length && je.hasOwnProperty(e.content)
              ? new Qe(this.input, e.begin, e.end, this.file)
              : r
              ? new $e(e, n[0])
              : new Ke(e, n, this.p);
          }
        }),
        (t.prototype.readRange = function () {
          this.skipBlank();
          var t = this.p;
          if ("(" === this.peek()) {
            ++this.p;
            var e = this.readValueOrThrow();
            this.p += 2;
            var r = this.readValueOrThrow();
            return ++this.p, new ir(this.input, t, this.p, e, r, this.file);
          }
        }),
        (t.prototype.readValueOrThrow = function () {
          var t = this,
            e = this.readValue();
          return (
            oe(e, function () {
              return "unexpected token ".concat(
                t.snapshot(),
                ", value expected"
              );
            }),
            e
          );
        }),
        (t.prototype.readQuoted = function () {
          this.skipBlank();
          var t = this.p;
          if (8 & this.peekType()) {
            ++this.p;
            for (
              var e = !1;
              this.p < this.N &&
              (++this.p, this.input[this.p - 1] !== this.input[t] || e);

            )
              e ? (e = !1) : "\\" === this.input[this.p - 1] && (e = !0);
            return new rr(this.input, t, this.p, this.file);
          }
        }),
        (t.prototype.readFileNameTemplate = function (t) {
          var e, r, n;
          return ht(this, function (i) {
            switch (i.label) {
              case 0:
                (e = t.outputDelimiterLeft),
                  (r = [",", " ", e]),
                  (n = new Set(r)),
                  (i.label = 1);
              case 1:
                return this.p < this.N && !n.has(this.peek())
                  ? [
                      4,
                      this.match(e)
                        ? this.readOutputToken(t)
                        : this.readHTMLToken(r),
                    ]
                  : [3, 3];
              case 2:
                return i.sent(), [3, 1];
              case 3:
                return [2];
            }
          });
        }),
        (t.prototype.match = function (t) {
          for (var e = 0; e < t.length; e++)
            if (t[e] !== this.input[this.p + e]) return !1;
          return !0;
        }),
        (t.prototype.rmatch = function (t) {
          for (var e = 0; e < t.length; e++)
            if (t[t.length - 1 - e] !== this.input[this.p - 1 - e]) return !1;
          return !0;
        }),
        (t.prototype.peekType = function (t) {
          return void 0 === t && (t = 0), Jt[this.input.charCodeAt(this.p + t)];
        }),
        (t.prototype.peek = function (t) {
          return void 0 === t && (t = 0), this.input[this.p + t];
        }),
        (t.prototype.skipBlank = function () {
          for (; 4 & this.peekType(); ) ++this.p;
        }),
        t
      );
    })(),
    ur = (function (t) {
      function e(e, r, n, i, o) {
        var a = this,
          s = i.trimTagLeft,
          u = i.trimTagRight,
          c = i.tagDelimiterLeft,
          l = i.tagDelimiterRight,
          p = e.slice(r + c.length, n - l.length);
        a = t.call(this, he.Tag, p, e, r, n, s, u, o) || this;
        var f = new sr(a.content, i.operatorsTrie);
        if (((a.name = f.readIdentifier().getText()), !a.name))
          throw new Xt("illegal tag syntax", a);
        return f.skipBlank(), (a.args = f.remaining()), a;
      }
      return pt(e, t), e;
    })(Ue),
    cr = (function () {
      function t(t, e) {
        var r, n;
        this.hash = {};
        var i = new sr(t, {});
        try {
          for (
            var o = vt(i.readHashes(e)), a = o.next();
            !a.done;
            a = o.next()
          ) {
            var s = a.value;
            this.hash[s.name.content] = s.value;
          }
        } catch (t) {
          r = { error: t };
        } finally {
          try {
            a && !a.done && (n = o.return) && n.call(o);
          } finally {
            if (r) throw r.error;
          }
        }
      }
      return (
        (t.prototype.render = function (t) {
          var e, r, n, i, o, a, s, u, c, l;
          return ht(this, function (p) {
            switch (p.label) {
              case 0:
                (e = {}), (p.label = 1);
              case 1:
                p.trys.push([1, 8, 9, 10]),
                  (r = vt(Object.keys(this.hash))),
                  (n = r.next()),
                  (p.label = 2);
              case 2:
                return n.done
                  ? [3, 7]
                  : ((i = n.value),
                    (o = e),
                    (a = i),
                    void 0 !== this.hash[i] ? [3, 3] : ((s = !0), [3, 5]));
              case 3:
                return [4, ze(this.hash[i], t)];
              case 4:
                (s = p.sent()), (p.label = 5);
              case 5:
                (o[a] = s), (p.label = 6);
              case 6:
                return (n = r.next()), [3, 2];
              case 7:
                return [3, 10];
              case 8:
                return (u = p.sent()), (c = { error: u }), [3, 10];
              case 9:
                try {
                  n && !n.done && (l = r.return) && l.call(r);
                } finally {
                  if (c) throw c.error;
                }
                return [7];
              case 10:
                return [2, e];
            }
          });
        }),
        t
      );
    })();
  var lr = (function () {
      function t(t, e, r, n) {
        (this.name = t),
          (this.impl = e || jt),
          (this.args = r),
          (this.liquid = n);
      }
      return (
        (t.prototype.render = function (t, e) {
          var r,
            n,
            i = [];
          try {
            for (var o = vt(this.args), a = o.next(); !a.done; a = o.next()) {
              var s = a.value;
              Et(s) ? i.push([s[0], ze(s[1], e)]) : i.push(ze(s, e));
            }
          } catch (t) {
            r = { error: t };
          } finally {
            try {
              a && !a.done && (n = o.return) && n.call(o);
            } finally {
              if (r) throw r.error;
            }
          }
          return this.impl.apply(
            { context: e, liquid: this.liquid },
            gt([t], mt(i), !1)
          );
        }),
        t
      );
    })(),
    pr = (function () {
      function t(t, e) {
        this.filters = [];
        var r = new sr(t, e.options.operatorsTrie);
        (this.initial = r.readExpression()),
          (this.filters = r.readFilters().map(function (t) {
            var r = t.name,
              n = t.args;
            return new lr(r, e.filters.get(r), n, e);
          }));
      }
      return (
        (t.prototype.value = function (t, e) {
          var r, n, i, o, a, s;
          return ht(this, function (u) {
            switch (u.label) {
              case 0:
                return (
                  (e =
                    e ||
                    (t.opts.lenientIf &&
                      this.filters.length > 0 &&
                      "default" === this.filters[0].name)),
                  [4, this.initial.evaluate(t, e)]
                );
              case 1:
                (r = u.sent()), (u.label = 2);
              case 2:
                u.trys.push([2, 7, 8, 9]),
                  (n = vt(this.filters)),
                  (i = n.next()),
                  (u.label = 3);
              case 3:
                return i.done ? [3, 6] : [4, i.value.render(r, t)];
              case 4:
                (r = u.sent()), (u.label = 5);
              case 5:
                return (i = n.next()), [3, 3];
              case 6:
                return [3, 9];
              case 7:
                return (o = u.sent()), (a = { error: o }), [3, 9];
              case 8:
                try {
                  i && !i.done && (s = n.return) && s.call(n);
                } finally {
                  if (a) throw a.error;
                }
                return [7];
              case 9:
                return [2, r];
            }
          });
        }),
        t
      );
    })(),
    fr = (function (t) {
      function e(e, r, n) {
        var i = t.call(this, e) || this;
        i.name = e.name;
        var o = n.tags.get(e.name);
        return (
          (i.impl = Object.create(o)),
          (i.impl.liquid = n),
          i.impl.parse && i.impl.parse(e, r),
          i
        );
      }
      return (
        pt(e, t),
        (e.prototype.render = function (t, e) {
          var r, n;
          return ht(this, function (i) {
            switch (i.label) {
              case 0:
                return [4, new cr(this.token.args).render(t)];
              case 1:
                return (
                  (r = i.sent()),
                  St((n = this.impl).render) ? [4, n.render(t, e, r)] : [3, 3]
                );
              case 2:
                return [2, i.sent()];
              case 3:
                return [2];
            }
          });
        }),
        e
      );
    })(Le),
    dr = (function (t) {
      function e(e, r) {
        var n = t.call(this, e) || this;
        return (n.value = new pr(e.content, r)), n;
      }
      return (
        pt(e, t),
        (e.prototype.render = function (t, e) {
          var r;
          return ht(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, this.value.value(t, !1)];
              case 1:
                return (r = n.sent()), e.write(r), [2];
            }
          });
        }),
        e
      );
    })(Le),
    hr = (function (t) {
      function e(e) {
        var r = t.call(this, e) || this;
        return (r.str = e.getContent()), r;
      }
      return (
        pt(e, t),
        (e.prototype.render = function (t, e) {
          return ht(this, function (t) {
            return e.write(this.str), [2];
          });
        }),
        e
      );
    })(Le),
    vr = (function () {
      function t(t) {
        (this.liquid = t),
          (this.cache = this.liquid.options.cache),
          (this.fs = this.liquid.options.fs),
          (this.parseFile = this.cache
            ? this._parseFileCached
            : this._parseFile),
          (this.loader = new ae(this.liquid.options));
      }
      return (
        (t.prototype.parse = function (t, e) {
          var r = new sr(
            t,
            this.liquid.options.operatorsTrie,
            e
          ).readTopLevelTokens(this.liquid.options);
          return this.parseTokens(r);
        }),
        (t.prototype.parseTokens = function (t) {
          for (var e, r = []; (e = t.shift()); ) r.push(this.parseToken(e, t));
          return r;
        }),
        (t.prototype.parseToken = function (t, e) {
          try {
            return _e(t)
              ? new fr(t, e, this.liquid)
              : be(t)
              ? new dr(t, this.liquid)
              : new hr(t);
          } catch (e) {
            throw new Zt(e, t);
          }
        }),
        (t.prototype.parseStream = function (t) {
          var e = this;
          return new Ae(t, function (t, r) {
            return e.parseToken(t, r);
          });
        }),
        (t.prototype._parseFileCached = function (t, e, r, n) {
          var i, o, a;
          return (
            void 0 === r && (r = ne.Root),
            ht(this, function (s) {
              switch (s.label) {
                case 0:
                  return (
                    (i = this.loader.shouldLoadRelative(t)
                      ? n + "," + t
                      : r + ":" + t),
                    [4, this.cache.read(i)]
                  );
                case 1:
                  if ((o = s.sent())) return [2, o];
                  (a = pe(this._parseFile(t, e, r, n))),
                    this.cache.write(i, a),
                    (s.label = 2);
                case 2:
                  return s.trys.push([2, 4, , 5]), [4, a];
                case 3:
                  return [2, s.sent()];
                case 4:
                  return s.sent(), this.cache.remove(i), [3, 5];
                case 5:
                  return [2, []];
              }
            })
          );
        }),
        (t.prototype._parseFile = function (t, e, r, n) {
          var i, o, a, s;
          return (
            void 0 === r && (r = ne.Root),
            ht(this, function (u) {
              switch (u.label) {
                case 0:
                  return [4, this.loader.lookup(t, r, e, n)];
                case 1:
                  return (
                    (i = u.sent()),
                    (a = (o = this.liquid).parse),
                    e ? ((s = this.fs.readFileSync(i)), [3, 4]) : [3, 2]
                  );
                case 2:
                  return [4, this.fs.readFile(i)];
                case 3:
                  (s = u.sent()), (u.label = 4);
                case 4:
                  return [2, a.apply(o, [s, i])];
              }
            })
          );
        }),
        t
      );
    })(),
    mr = {
      parse: function (t) {
        var e = new sr(t.args, this.liquid.options.operatorsTrie);
        (this.key = e.readIdentifier().content),
          e.skipBlank(),
          oe("=" === e.peek(), function () {
            return "illegal token ".concat(t.getText());
          }),
          e.advance(),
          (this.value = e.remaining());
      },
      render: function (t) {
        var e, r;
        return ht(this, function (n) {
          switch (n.label) {
            case 0:
              return (
                (e = t.bottom()),
                (r = this.key),
                [4, this.liquid._evalValue(this.value, t)]
              );
            case 1:
              return (e[r] = n.sent()), [2];
          }
        });
      },
    };
  function gr(t) {
    return Et(t)
      ? t
      : _t(t) && t.length > 0
      ? [t]
      : Pt(t)
      ? Object.keys(t).map(function (e) {
          return [e, t[e]];
        })
      : [];
  }
  function yr(t) {
    return Et(t) ? t : [t];
  }
  var wr = (function (t) {
      function e(e, r, n) {
        var i = t.call(this) || this;
        return (
          (i.i = 0), (i.length = e), (i.name = "".concat(n, "-").concat(r)), i
        );
      }
      return (
        pt(e, t),
        (e.prototype.next = function () {
          this.i++;
        }),
        (e.prototype.index0 = function () {
          return this.i;
        }),
        (e.prototype.index = function () {
          return this.i + 1;
        }),
        (e.prototype.first = function () {
          return 0 === this.i;
        }),
        (e.prototype.last = function () {
          return this.i === this.length - 1;
        }),
        (e.prototype.rindex = function () {
          return this.length - this.i;
        }),
        (e.prototype.rindex0 = function () {
          return this.length - this.i - 1;
        }),
        (e.prototype.valueOf = function () {
          return JSON.stringify(this);
        }),
        e
      );
    })(yt),
    br = ["offset", "limit", "reversed"],
    _r = {
      type: "block",
      parse: function (t, e) {
        var r,
          n = this,
          i = new sr(t.args, this.liquid.options.operatorsTrie),
          o = i.readIdentifier(),
          a = i.readIdentifier(),
          s = i.readValue();
        oe(o.size() && "in" === a.content && s, function () {
          return "illegal tag: ".concat(t.getText());
        }),
          (this.variable = o.content),
          (this.collection = s),
          (this.hash = new cr(i.remaining())),
          (this.templates = []),
          (this.elseTemplates = []);
        var u = this.liquid.parser
          .parseStream(e)
          .on("start", function () {
            return (r = n.templates);
          })
          .on("tag:else", function () {
            return (r = n.elseTemplates);
          })
          .on("tag:endfor", function () {
            return u.stop();
          })
          .on("template", function (t) {
            return r.push(t);
          })
          .on("end", function () {
            throw new Error("tag ".concat(t.getText(), " not closed"));
          });
        u.start();
      },
      render: function (t, e) {
        var r, n, i, o, a, s, u, c, l, p, f, d, h;
        return ht(this, function (v) {
          switch (v.label) {
            case 0:
              return (
                (r = this.liquid.renderer),
                (i = gr),
                [4, ze(this.collection, t)]
              );
            case 1:
              return (n = i.apply(void 0, [v.sent()])).length
                ? [3, 3]
                : [4, r.renderTemplates(this.elseTemplates, t, e)];
            case 2:
              return v.sent(), [2];
            case 3:
              return (
                (o =
                  "continue-" +
                  this.variable +
                  "-" +
                  this.collection.getText()),
                t.push({ continue: t.getRegister(o) }),
                [4, this.hash.render(t)]
              );
            case 4:
              (a = v.sent()),
                t.pop(),
                (s = this.liquid.options.orderedFilterParameters
                  ? Object.keys(a).filter(function (t) {
                      return br.includes(t);
                    })
                  : br.filter(function (t) {
                      return void 0 !== a[t];
                    })),
                (n = s.reduce(function (t, e) {
                  return "offset" === e
                    ? ((r = t), (n = a.offset), r.slice(n))
                    : "limit" === e
                    ? (function (t, e) {
                        return t.slice(0, e);
                      })(t, a.limit)
                    : (function (t) {
                        return gt([], mt(t), !1).reverse();
                      })(t);
                  var r, n;
                }, n)),
                t.setRegister(o, (a.offset || 0) + n.length),
                (u = {
                  forloop: new wr(
                    n.length,
                    this.collection.getText(),
                    this.variable
                  ),
                }),
                t.push(u),
                (v.label = 5);
            case 5:
              v.trys.push([5, 10, 11, 12]),
                (c = vt(n)),
                (l = c.next()),
                (v.label = 6);
            case 6:
              return l.done
                ? [3, 9]
                : ((p = l.value),
                  (u[this.variable] = p),
                  [4, r.renderTemplates(this.templates, t, e)]);
            case 7:
              if ((v.sent(), e.break)) return (e.break = !1), [3, 9];
              (e.continue = !1), u.forloop.next(), (v.label = 8);
            case 8:
              return (l = c.next()), [3, 6];
            case 9:
              return [3, 12];
            case 10:
              return (f = v.sent()), (d = { error: f }), [3, 12];
            case 11:
              try {
                l && !l.done && (h = c.return) && h.call(c);
              } finally {
                if (d) throw d.error;
              }
              return [7];
            case 12:
              return t.pop(), [2];
          }
        });
      },
    };
  var Sr = {
    parse: function (t, e) {
      var r = this,
        n = new sr(t.args, this.liquid.options.operatorsTrie);
      (this.variable = (function (t) {
        var e = t.readIdentifier().content;
        if (e) return e;
        var r = t.readQuoted();
        if (r) return He(r);
      })(n)),
        oe(this.variable, function () {
          return "".concat(t.args, " not valid identifier");
        }),
        (this.templates = []);
      var i = this.liquid.parser.parseStream(e);
      i
        .on("tag:endcapture", function () {
          return i.stop();
        })
        .on("template", function (t) {
          return r.templates.push(t);
        })
        .on("end", function () {
          throw new Error("tag ".concat(t.getText(), " not closed"));
        }),
        i.start();
    },
    render: function (t) {
      var e;
      return ht(this, function (r) {
        switch (r.label) {
          case 0:
            return [4, this.liquid.renderer.renderTemplates(this.templates, t)];
          case 1:
            return (e = r.sent()), (t.bottom()[this.variable] = e), [2];
        }
      });
    },
  };
  var xr,
    Tr = {
      parse: function (t, e) {
        var r = this;
        (this.cond = new pr(t.args, this.liquid)),
          (this.cases = []),
          (this.elseTemplates = []);
        var n = [],
          i = this.liquid.parser
            .parseStream(e)
            .on("tag:when", function (t) {
              n = [];
              for (
                var e = new sr(t.args, r.liquid.options.operatorsTrie);
                !e.end();

              ) {
                var i = e.readValue();
                r.cases.push({ val: i, templates: n }), e.readTo(",");
              }
            })
            .on("tag:else", function () {
              return (n = r.elseTemplates);
            })
            .on("tag:endcase", function () {
              return i.stop();
            })
            .on("template", function (t) {
              return n.push(t);
            })
            .on("end", function () {
              throw new Error("tag ".concat(t.getText(), " not closed"));
            });
        i.start();
      },
      render: function (t, e) {
        var r, n, i, o, a, s, u, c, l;
        return ht(this, function (p) {
          switch (p.label) {
            case 0:
              return (
                (r = this.liquid.renderer),
                (i = Tt),
                [4, this.cond.value(t, t.opts.lenientIf)]
              );
            case 1:
              (n = i.apply(void 0, [p.sent()])), (p.label = 2);
            case 2:
              p.trys.push([2, 7, 8, 9]),
                (o = vt(this.cases)),
                (a = o.next()),
                (p.label = 3);
            case 3:
              return a.done
                ? [3, 6]
                : ((s = a.value),
                  ze(s.val, t, t.opts.lenientIf) !== n
                    ? [3, 5]
                    : [4, r.renderTemplates(s.templates, t, e)]);
            case 4:
              return p.sent(), [2];
            case 5:
              return (a = o.next()), [3, 3];
            case 6:
              return [3, 9];
            case 7:
              return (u = p.sent()), (c = { error: u }), [3, 9];
            case 8:
              try {
                a && !a.done && (l = o.return) && l.call(o);
              } finally {
                if (c) throw c.error;
              }
              return [7];
            case 9:
              return [4, r.renderTemplates(this.elseTemplates, t, e)];
            case 10:
              return p.sent(), [2];
          }
        });
      },
    },
    Or = {
      parse: function (t, e) {
        var r = this.liquid.parser.parseStream(e);
        r
          .on("token", function (t) {
            "endcomment" === t.name && r.stop();
          })
          .on("end", function () {
            throw new Error("tag ".concat(t.getText(), " not closed"));
          }),
          r.start();
      },
    };
  !(function (t) {
    (t[(t.OUTPUT = 0)] = "OUTPUT"), (t[(t.STORE = 1)] = "STORE");
  })(xr || (xr = {}));
  var kr = xr,
    qr = {
      parseFilePath: Er,
      renderFilePath: Lr,
      parse: function (t) {
        var e = t.args,
          r = new sr(e, this.liquid.options.operatorsTrie);
        for (
          this.file = this.parseFilePath(r, this.liquid),
            this.currentFile = t.file;
          !r.end();

        ) {
          r.skipBlank();
          var n = r.p,
            i = r.readIdentifier();
          if (
            ("with" === i.content || "for" === i.content) &&
            (r.skipBlank(), ":" !== r.peek())
          ) {
            var o = r.readValue();
            if (o) {
              var a = r.p,
                s = void 0;
              "as" === r.readIdentifier().content
                ? (s = r.readIdentifier())
                : (r.p = a),
                (this[i.content] = { value: o, alias: s && s.content }),
                r.skipBlank(),
                "," === r.peek() && r.advance();
              continue;
            }
          }
          r.p = n;
          break;
        }
        this.hash = new cr(r.remaining());
      },
      render: function (t, e) {
        var r, n, i, o, a, s, u, c, l, p, f, d, h, v, m, g, y, w, b, _;
        return ht(this, function (S) {
          switch (S.label) {
            case 0:
              return (
                (n = (r = this).liquid),
                (i = r.hash),
                [4, this.renderFilePath(this.file, t, n)]
              );
            case 1:
              return (
                oe((o = S.sent()), function () {
                  return 'illegal filename "'.concat(o, '"');
                }),
                (a = new ie({}, t.opts, {
                  sync: t.sync,
                  globals: t.globals,
                  strictVariables: t.strictVariables,
                })),
                (s = a.bottom()),
                (u = ft),
                (c = [s]),
                [4, i.render(t)]
              );
            case 2:
              if (
                (u.apply(void 0, c.concat([S.sent()])),
                this.with &&
                  ((l = this.with),
                  (f = l.value),
                  (d = l.alias),
                  (s[d || o] = ze(f, t))),
                !this.for)
              )
                return [3, 12];
              (p = this.for),
                (f = p.value),
                (d = p.alias),
                (h = gr((h = ze(f, t)))),
                (s.forloop = new wr(h.length, f.getText(), d)),
                (S.label = 3);
            case 3:
              S.trys.push([3, 9, 10, 11]),
                (v = vt(h)),
                (m = v.next()),
                (S.label = 4);
            case 4:
              return m.done
                ? [3, 8]
                : ((g = m.value),
                  (s[d] = g),
                  [4, n._parsePartialFile(o, a.sync, this.currentFile)]);
            case 5:
              return (w = S.sent()), [4, n.renderer.renderTemplates(w, a, e)];
            case 6:
              S.sent(), s.forloop.next(), (S.label = 7);
            case 7:
              return (m = v.next()), [3, 4];
            case 8:
              return [3, 11];
            case 9:
              return (y = S.sent()), (b = { error: y }), [3, 11];
            case 10:
              try {
                m && !m.done && (_ = v.return) && _.call(v);
              } finally {
                if (b) throw b.error;
              }
              return [7];
            case 11:
              return [3, 15];
            case 12:
              return [4, n._parsePartialFile(o, a.sync, this.currentFile)];
            case 13:
              return (w = S.sent()), [4, n.renderer.renderTemplates(w, a, e)];
            case 14:
              S.sent(), (S.label = 15);
            case 15:
              return [2];
          }
        });
      },
    };
  function Er(t, e) {
    if (e.options.dynamicPartials) {
      var r = t.readValue();
      if (void 0 === r)
        throw new TypeError('illegal argument "'.concat(t.input, '"'));
      return "none" === r.getText() ? null : Se(r) ? Ar(e.parse(He(r))) : r;
    }
    var n = gt([], mt(t.readFileNameTemplate(e.options)), !1),
      i = Ar(e.parser.parseTokens(n));
    return "none" === i ? null : i;
  }
  function Ar(t) {
    return 1 === t.length && we(t[0].token) ? t[0].token.getContent() : t;
  }
  function Lr(t, e, r) {
    return "string" == typeof t
      ? t
      : Array.isArray(t)
      ? r.renderer.renderTemplates(t, e)
      : ze(t, e);
  }
  var Pr = {
      parseFilePath: Er,
      renderFilePath: Lr,
      parse: function (t) {
        var e = t.args,
          r = new sr(e, this.liquid.options.operatorsTrie);
        (this.file = this.parseFilePath(r, this.liquid)),
          (this.currentFile = t.file);
        var n = r.p;
        "with" === r.readIdentifier().content
          ? (r.skipBlank(),
            ":" !== r.peek() ? (this.withVar = r.readValue()) : (r.p = n))
          : (r.p = n),
          (this.hash = new cr(
            r.remaining(),
            this.liquid.options.jekyllInclude
          ));
      },
      render: function (t, e) {
        var r, n, i, o, a, s, u, c, l;
        return ht(this, function (p) {
          switch (p.label) {
            case 0:
              return (
                (n = (r = this).liquid),
                (i = r.hash),
                (o = r.withVar),
                (a = n.renderer),
                [4, this.renderFilePath(this.file, t, n)]
              );
            case 1:
              return (
                oe((s = p.sent()), function () {
                  return 'illegal filename "'.concat(s, '"');
                }),
                (u = t.saveRegister("blocks", "blockMode")),
                t.setRegister("blocks", {}),
                t.setRegister("blockMode", kr.OUTPUT),
                [4, i.render(t)]
              );
            case 2:
              return (
                (c = p.sent()),
                o && (c[s] = ze(o, t)),
                [4, n._parsePartialFile(s, t.sync, this.currentFile)]
              );
            case 3:
              return (
                (l = p.sent()),
                t.push(t.opts.jekyllInclude ? { include: c } : c),
                [4, a.renderTemplates(l, t, e)]
              );
            case 4:
              return p.sent(), t.pop(), t.restoreRegister(u), [2];
          }
        });
      },
    },
    Fr = {
      parse: function (t) {
        var e = new sr(t.args, this.liquid.options.operatorsTrie);
        this.variable = e.readIdentifier().content;
      },
      render: function (t, e) {
        var r = t.environments;
        Ot(r[this.variable]) || (r[this.variable] = 0),
          e.write(xt(--r[this.variable]));
      },
    },
    Cr = {
      parse: function (t) {
        var e = new sr(t.args, this.liquid.options.operatorsTrie),
          r = e.readValue();
        for (
          e.skipBlank(),
            this.candidates = [],
            r &&
              (":" === e.peek()
                ? ((this.group = r), e.advance())
                : this.candidates.push(r));
          !e.end();

        ) {
          var n = e.readValue();
          n && this.candidates.push(n), e.readTo(",");
        }
        oe(this.candidates.length, function () {
          return "empty candidates: ".concat(t.getText());
        });
      },
      render: function (t, e) {
        var r = ze(this.group, t),
          n = "cycle:".concat(r, ":") + this.candidates.join(","),
          i = t.getRegister("cycle"),
          o = i[n];
        void 0 === o && (o = i[n] = 0);
        var a = this.candidates[o];
        (o = (o + 1) % this.candidates.length), (i[n] = o);
        var s = ze(a, t);
        e.write(s);
      },
    },
    Nr = {
      parse: function (t, e) {
        var r,
          n = this;
        (this.branches = []),
          (this.elseTemplates = []),
          this.liquid.parser
            .parseStream(e)
            .on("start", function () {
              return n.branches.push({
                predicate: new pr(t.args, n.liquid),
                templates: (r = []),
              });
            })
            .on("tag:elsif", function (t) {
              return n.branches.push({
                predicate: new pr(t.args, n.liquid),
                templates: (r = []),
              });
            })
            .on("tag:else", function () {
              return (r = n.elseTemplates);
            })
            .on("tag:endif", function () {
              this.stop();
            })
            .on("template", function (t) {
              return r.push(t);
            })
            .on("end", function () {
              throw new Error("tag ".concat(t.getText(), " not closed"));
            })
            .start();
      },
      render: function (t, e) {
        var r, n, i, o, a, s, u, c, l;
        return ht(this, function (p) {
          switch (p.label) {
            case 0:
              (r = this.liquid.renderer), (p.label = 1);
            case 1:
              p.trys.push([1, 7, 8, 9]),
                (n = vt(this.branches)),
                (i = n.next()),
                (p.label = 2);
            case 2:
              return i.done
                ? [3, 6]
                : ((o = i.value),
                  (a = o.predicate),
                  (s = o.templates),
                  [4, a.value(t, t.opts.lenientIf)]);
            case 3:
              return Ht(p.sent(), t) ? [4, r.renderTemplates(s, t, e)] : [3, 5];
            case 4:
              return p.sent(), [2];
            case 5:
              return (i = n.next()), [3, 2];
            case 6:
              return [3, 9];
            case 7:
              return (u = p.sent()), (c = { error: u }), [3, 9];
            case 8:
              try {
                i && !i.done && (l = n.return) && l.call(n);
              } finally {
                if (c) throw c.error;
              }
              return [7];
            case 9:
              return [4, r.renderTemplates(this.elseTemplates, t, e)];
            case 10:
              return p.sent(), [2];
          }
        });
      },
    },
    jr = {
      parse: function (t) {
        var e = new sr(t.args, this.liquid.options.operatorsTrie);
        this.variable = e.readIdentifier().content;
      },
      render: function (t, e) {
        var r = t.environments;
        Ot(r[this.variable]) || (r[this.variable] = 0);
        var n = r[this.variable];
        r[this.variable]++, e.write(xt(n));
      },
    },
    Rr = {
      parseFilePath: Er,
      renderFilePath: Lr,
      parse: function (t, e) {
        var r = new sr(t.args, this.liquid.options.operatorsTrie);
        (this.file = this.parseFilePath(r, this.liquid)),
          (this.currentFile = t.file),
          (this.hash = new cr(r.remaining())),
          (this.tpls = this.liquid.parser.parseTokens(e));
      },
      render: function (t, e) {
        var r, n, i, o, a, s, u, c, l, p, f;
        return ht(this, function (d) {
          switch (d.label) {
            case 0:
              return (
                (n = (r = this).liquid),
                (i = r.hash),
                (o = r.file),
                (a = n.renderer),
                null !== o
                  ? [3, 2]
                  : (t.setRegister("blockMode", kr.OUTPUT),
                    [4, a.renderTemplates(this.tpls, t, e)])
              );
            case 1:
              return d.sent(), [2];
            case 2:
              return [4, this.renderFilePath(this.file, t, n)];
            case 3:
              return (
                oe((s = d.sent()), function () {
                  return 'illegal filename "'.concat(s, '"');
                }),
                [4, n._parseLayoutFile(s, t.sync, this.currentFile)]
              );
            case 4:
              return (
                (u = d.sent()),
                t.setRegister("blockMode", kr.STORE),
                [4, a.renderTemplates(this.tpls, t)]
              );
            case 5:
              return (
                (c = d.sent()),
                void 0 === (l = t.getRegister("blocks"))[""] &&
                  (l[""] = function (t, e) {
                    return e.write(c);
                  }),
                t.setRegister("blockMode", kr.OUTPUT),
                (f = (p = t).push),
                [4, i.render(t)]
              );
            case 6:
              return f.apply(p, [d.sent()]), [4, a.renderTemplates(u, t, e)];
            case 7:
              return d.sent(), t.pop(), [2];
          }
        });
      },
    },
    Dr = (function (t) {
      function e(e) {
        void 0 === e &&
          (e = function () {
            return "";
          });
        var r = t.call(this) || this;
        return (r.superBlockRender = e), r;
      }
      return (
        pt(e, t),
        (e.prototype.super = function () {
          return this.superBlockRender();
        }),
        e
      );
    })(yt),
    Mr = {
      parse: function (t, e) {
        var r = this,
          n = /\w+/.exec(t.args);
        (this.block = n ? n[0] : ""),
          (this.tpls = []),
          this.liquid.parser
            .parseStream(e)
            .on("tag:endblock", function () {
              this.stop();
            })
            .on("template", function (t) {
              return r.tpls.push(t);
            })
            .on("end", function () {
              throw new Error("tag ".concat(t.getText(), " not closed"));
            })
            .start();
      },
      render: function (t, e) {
        var r;
        return ht(this, function (n) {
          switch (n.label) {
            case 0:
              return (
                (r = this.getBlockRender(t)),
                t.getRegister("blockMode") !== kr.STORE
                  ? [3, 1]
                  : ((t.getRegister("blocks")[this.block] = r), [3, 3])
              );
            case 1:
              return [4, r(new Dr(), e)];
            case 2:
              n.sent(), (n.label = 3);
            case 3:
              return [2];
          }
        });
      },
      getBlockRender: function (t) {
        var e = this.liquid,
          r = this.tpls,
          n = t.getRegister("blocks")[this.block],
          i = function (n, i) {
            return ht(this, function (o) {
              switch (o.label) {
                case 0:
                  return (
                    t.push({ block: n }),
                    [4, e.renderer.renderTemplates(r, t, i)]
                  );
                case 1:
                  return o.sent(), t.pop(), [2];
              }
            });
          };
        return n
          ? function (t, e) {
              return n(
                new Dr(function () {
                  return i(t, e);
                }),
                e
              );
            }
          : i;
      },
    },
    Ir = {
      parse: function (t, e) {
        var r = this;
        this.tokens = [];
        var n = this.liquid.parser.parseStream(e);
        n
          .on("token", function (t) {
            "endraw" === t.name ? n.stop() : r.tokens.push(t);
          })
          .on("end", function () {
            throw new Error("tag ".concat(t.getText(), " not closed"));
          }),
          n.start();
      },
      render: function () {
        return this.tokens
          .map(function (t) {
            return t.getText();
          })
          .join("");
      },
    },
    Vr = (function (t) {
      function e(e, r, n, i) {
        var o = t.call(this, e, n, i) || this;
        return (o.length = e), (o.cols = r), o;
      }
      return (
        pt(e, t),
        (e.prototype.row = function () {
          return Math.floor(this.i / this.cols) + 1;
        }),
        (e.prototype.col0 = function () {
          return this.i % this.cols;
        }),
        (e.prototype.col = function () {
          return this.col0() + 1;
        }),
        (e.prototype.col_first = function () {
          return 0 === this.col0();
        }),
        (e.prototype.col_last = function () {
          return this.col() === this.cols;
        }),
        e
      );
    })(wr),
    Br = {
      parse: function (t, e) {
        var r = this,
          n = new sr(t.args, this.liquid.options.operatorsTrie),
          i = n.readIdentifier();
        n.skipBlank();
        var o,
          a = n.readIdentifier();
        oe(a && "in" === a.content, function () {
          return "illegal tag: ".concat(t.getText());
        }),
          (this.variable = i.content),
          (this.collection = n.readValue()),
          (this.hash = new cr(n.remaining())),
          (this.templates = []);
        var s = this.liquid.parser
          .parseStream(e)
          .on("start", function () {
            return (o = r.templates);
          })
          .on("tag:endtablerow", function () {
            return s.stop();
          })
          .on("template", function (t) {
            return o.push(t);
          })
          .on("end", function () {
            throw new Error("tag ".concat(t.getText(), " not closed"));
          });
        s.start();
      },
      render: function (t, e) {
        var r, n, i, o, a, s, u, c, l, p;
        return ht(this, function (f) {
          switch (f.label) {
            case 0:
              return (n = gr), [4, ze(this.collection, t)];
            case 1:
              return (
                (r = n.apply(void 0, [f.sent()])), [4, this.hash.render(t)]
              );
            case 2:
              (i = f.sent()),
                (o = i.offset || 0),
                (a = void 0 === i.limit ? r.length : i.limit),
                (r = r.slice(o, o + a)),
                (s = i.cols || r.length),
                (u = this.liquid.renderer),
                (c = new Vr(
                  r.length,
                  s,
                  this.collection.getText(),
                  this.variable
                )),
                (l = { tablerowloop: c }),
                t.push(l),
                (p = 0),
                (f.label = 3);
            case 3:
              return p < r.length
                ? ((l[this.variable] = r[p]),
                  0 === c.col0() &&
                    (1 !== c.row() && e.write("</tr>"),
                    e.write('<tr class="row'.concat(c.row(), '">'))),
                  e.write('<td class="col'.concat(c.col(), '">')),
                  [4, u.renderTemplates(this.templates, t, e)])
                : [3, 6];
            case 4:
              f.sent(), e.write("</td>"), (f.label = 5);
            case 5:
              return p++, c.next(), [3, 3];
            case 6:
              return r.length && e.write("</tr>"), t.pop(), [2];
          }
        });
      },
    },
    zr = {
      assign: mr,
      for: _r,
      capture: Sr,
      case: Tr,
      comment: Or,
      include: Pr,
      render: qr,
      decrement: Fr,
      increment: jr,
      cycle: Cr,
      if: Nr,
      layout: Rr,
      block: Mr,
      raw: Ir,
      tablerow: Br,
      unless: {
        parse: function (t, e) {
          var r,
            n = this;
          (this.branches = []),
            (this.elseTemplates = []),
            this.liquid.parser
              .parseStream(e)
              .on("start", function () {
                return n.branches.push({
                  predicate: new pr(t.args, n.liquid),
                  test: Wt,
                  templates: (r = []),
                });
              })
              .on("tag:elsif", function (t) {
                return n.branches.push({
                  predicate: new pr(t.args, n.liquid),
                  test: Ht,
                  templates: (r = []),
                });
              })
              .on("tag:else", function () {
                return (r = n.elseTemplates);
              })
              .on("tag:endunless", function () {
                this.stop();
              })
              .on("template", function (t) {
                return r.push(t);
              })
              .on("end", function () {
                throw new Error("tag ".concat(t.getText(), " not closed"));
              })
              .start();
        },
        render: function (t, e) {
          var r, n, i, o, a, s, u, c, l, p, f;
          return ht(this, function (d) {
            switch (d.label) {
              case 0:
                (r = this.liquid.renderer), (d.label = 1);
              case 1:
                d.trys.push([1, 7, 8, 9]),
                  (n = vt(this.branches)),
                  (i = n.next()),
                  (d.label = 2);
              case 2:
                return i.done
                  ? [3, 6]
                  : ((o = i.value),
                    (a = o.predicate),
                    (s = o.test),
                    (u = o.templates),
                    [4, a.value(t, t.opts.lenientIf)]);
              case 3:
                return (
                  (c = d.sent()),
                  s(c, t) ? [4, r.renderTemplates(u, t, e)] : [3, 5]
                );
              case 4:
                return d.sent(), [2];
              case 5:
                return (i = n.next()), [3, 2];
              case 6:
                return [3, 9];
              case 7:
                return (l = d.sent()), (p = { error: l }), [3, 9];
              case 8:
                try {
                  i && !i.done && (f = n.return) && f.call(n);
                } finally {
                  if (p) throw p.error;
                }
                return [7];
              case 9:
                return [4, r.renderTemplates(this.elseTemplates, t, e)];
              case 10:
                return d.sent(), [2];
            }
          });
        },
      },
      break: {
        render: function (t, e) {
          e.break = !0;
        },
      },
      continue: {
        render: function (t, e) {
          e.continue = !0;
        },
      },
      echo: {
        parse: function (t) {
          this.value = new pr(t.args, this.liquid);
        },
        render: function (t, e) {
          var r;
          return ht(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, this.value.value(t, !1)];
              case 1:
                return (r = n.sent()), e.write(r), [2];
            }
          });
        },
      },
      liquid: {
        parse: function (t) {
          var e = new sr(
            t.args,
            this.liquid.options.operatorsTrie
          ).readLiquidTagTokens(this.liquid.options);
          this.tpls = this.liquid.parser.parseTokens(e);
        },
        render: function (t, e) {
          return ht(this, function (r) {
            switch (r.label) {
              case 0:
                return [
                  4,
                  this.liquid.renderer.renderTemplates(this.tpls, t, e),
                ];
              case 1:
                return r.sent(), [2];
            }
          });
        },
      },
    },
    Hr = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&#34;", "'": "&#39;" },
    Wr = { "&amp;": "&", "&lt;": "<", "&gt;": ">", "&#34;": '"', "&#39;": "'" };
  function Ur(t) {
    return xt(t).replace(/&|<|>|"|'/g, function (t) {
      return Hr[t];
    });
  }
  var Jr = Math.abs,
    Yr = Math.max,
    $r = Math.min,
    Gr = Math.ceil,
    Qr = Math.floor;
  var Xr = /%([-_0^#:]+)?(\d+)?([EO])?(.)/,
    Zr = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    Kr = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ],
    tn = Zr.map(nn),
    en = Kr.map(nn),
    rn = { 1: "st", 2: "nd", 3: "rd", default: "th" };
  function nn(t) {
    return t.slice(0, 3);
  }
  function on(t) {
    var e = (function (t) {
      var e = t.getFullYear();
      return !(0 != (3 & e) || !(e % 100 || (e % 400 == 0 && e)));
    })(t)
      ? 29
      : 28;
    return [31, e, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  }
  function an(t) {
    for (var e = 0, r = 0; r < t.getMonth(); ++r) e += on(t)[r];
    return e + t.getDate();
  }
  function sn(t, e) {
    var r = an(t) + (e - t.getDay()),
      n = 7 - new Date(t.getFullYear(), 0, 1).getDay() + e;
    return String(Math.floor((r - n) / 7) + 1);
  }
  var un = {
      d: 2,
      e: 2,
      H: 2,
      I: 2,
      j: 3,
      k: 2,
      l: 2,
      L: 3,
      m: 2,
      M: 2,
      S: 2,
      U: 2,
      W: 2,
    },
    cn = {
      a: " ",
      A: " ",
      b: " ",
      B: " ",
      c: " ",
      e: " ",
      k: " ",
      l: " ",
      p: " ",
      P: " ",
    },
    ln = {
      a: function (t) {
        return en[t.getDay()];
      },
      A: function (t) {
        return Kr[t.getDay()];
      },
      b: function (t) {
        return tn[t.getMonth()];
      },
      B: function (t) {
        return Zr[t.getMonth()];
      },
      c: function (t) {
        return t.toLocaleString();
      },
      C: function (t) {
        return (function (t) {
          return parseInt(t.getFullYear().toString().substring(0, 2), 10);
        })(t);
      },
      d: function (t) {
        return t.getDate();
      },
      e: function (t) {
        return t.getDate();
      },
      H: function (t) {
        return t.getHours();
      },
      I: function (t) {
        return String(t.getHours() % 12 || 12);
      },
      j: function (t) {
        return an(t);
      },
      k: function (t) {
        return t.getHours();
      },
      l: function (t) {
        return String(t.getHours() % 12 || 12);
      },
      L: function (t) {
        return t.getMilliseconds();
      },
      m: function (t) {
        return t.getMonth() + 1;
      },
      M: function (t) {
        return t.getMinutes();
      },
      N: function (t, e) {
        var r = Number(e.width) || 9;
        return (function (t, e, r) {
          return (
            void 0 === r && (r = " "),
            Nt(t, e, r, function (t, e) {
              return t + e;
            })
          );
        })(String(t.getMilliseconds()).substr(0, r), r, "0");
      },
      p: function (t) {
        return t.getHours() < 12 ? "AM" : "PM";
      },
      P: function (t) {
        return t.getHours() < 12 ? "am" : "pm";
      },
      q: function (t) {
        return (function (t) {
          var e = t.getDate().toString(),
            r = parseInt(e.slice(-1));
          return rn[r] || rn.default;
        })(t);
      },
      s: function (t) {
        return Math.round(t.getTime() / 1e3);
      },
      S: function (t) {
        return t.getSeconds();
      },
      u: function (t) {
        return t.getDay() || 7;
      },
      U: function (t) {
        return sn(t, 0);
      },
      w: function (t) {
        return t.getDay();
      },
      W: function (t) {
        return sn(t, 1);
      },
      x: function (t) {
        return t.toLocaleDateString();
      },
      X: function (t) {
        return t.toLocaleTimeString();
      },
      y: function (t) {
        return t.getFullYear().toString().substring(2, 4);
      },
      Y: function (t) {
        return t.getFullYear();
      },
      z: function (t, e) {
        var r = Math.abs(t.getTimezoneOffset()),
          n = Math.floor(r / 60),
          i = r % 60;
        return (
          (t.getTimezoneOffset() > 0 ? "-" : "+") +
          Ct(n, 2, "0") +
          (e.flags[":"] ? ":" : "") +
          Ct(i, 2, "0")
        );
      },
      t: function () {
        return "\t";
      },
      n: function () {
        return "\n";
      },
      "%": function () {
        return "%";
      },
    };
  function pn(t, e) {
    var r,
      n,
      i = mt(e, 5),
      o = i[0],
      a = i[1],
      s = void 0 === a ? "" : a,
      u = i[2],
      c = i[3],
      l = i[4],
      p = ln[l];
    if (!p) return o;
    var f = {};
    try {
      for (var d = vt(s), h = d.next(); !h.done; h = d.next()) {
        f[h.value] = !0;
      }
    } catch (t) {
      r = { error: t };
    } finally {
      try {
        h && !h.done && (n = d.return) && n.call(d);
      } finally {
        if (r) throw r.error;
      }
    }
    var v,
      m = String(p(t, { flags: f, width: u, modifier: c })),
      g = cn[l] || "0",
      y = u || un[l] || 0;
    return (
      f["^"]
        ? (m = m.toUpperCase())
        : f["#"] &&
          (m = gt([], mt((v = m)), !1).some(function (t) {
            return t >= "a" && t <= "z";
          })
            ? v.toUpperCase()
            : v.toLowerCase()),
      f._ ? (g = " ") : f[0] && (g = "0"),
      f["-"] && (y = 0),
      Ct(m, y, g)
    );
  }
  ln.h = ln.b;
  var fn = new Date().getTimezoneOffset(),
    dn = /([zZ]|([+-])(\d{2}):(\d{2}))$/,
    hn = (function () {
      function t(e, r) {
        if (e instanceof t) (this.date = e.date), (r = e.timezoneOffset);
        else {
          var n = 6e4 * (fn - r),
            i = new Date(e).getTime() + n;
          this.date = new Date(i);
        }
        this.timezoneOffset = r;
      }
      return (
        (t.prototype.getTime = function () {
          return this.date.getTime();
        }),
        (t.prototype.getMilliseconds = function () {
          return this.date.getMilliseconds();
        }),
        (t.prototype.getSeconds = function () {
          return this.date.getSeconds();
        }),
        (t.prototype.getMinutes = function () {
          return this.date.getMinutes();
        }),
        (t.prototype.getHours = function () {
          return this.date.getHours();
        }),
        (t.prototype.getDay = function () {
          return this.date.getDay();
        }),
        (t.prototype.getDate = function () {
          return this.date.getDate();
        }),
        (t.prototype.getMonth = function () {
          return this.date.getMonth();
        }),
        (t.prototype.getFullYear = function () {
          return this.date.getFullYear();
        }),
        (t.prototype.toLocaleTimeString = function (t) {
          return this.date.toLocaleTimeString(t);
        }),
        (t.prototype.toLocaleDateString = function (t) {
          return this.date.toLocaleDateString(t);
        }),
        (t.prototype.getTimezoneOffset = function () {
          return this.timezoneOffset;
        }),
        (t.createDateFixedToTimezone = function (e) {
          var r = e.match(dn);
          if (r && "Z" === r[1]) return new t(+new Date(e), 0);
          if (r && r[2] && r[3] && r[4]) {
            var n = mt(r, 5),
              i = n[2],
              o = n[3],
              a = n[4],
              s =
                ("+" === i ? -1 : 1) * (60 * parseInt(o, 10) + parseInt(a, 10));
            return new t(+new Date(e), s);
          }
          return new Date(e);
        }),
        t
      );
    })();
  var vn = Object.freeze({
      __proto__: null,
      escape: Ur,
      escapeOnce: function (t) {
        return Ur(
          (function (t) {
            return String(t).replace(/&(amp|lt|gt|#34|#39);/g, function (t) {
              return Wr[t];
            });
          })(t)
        );
      },
      newlineToBr: function (t) {
        return t.replace(/\n/g, "<br />\n");
      },
      stripHtml: function (t) {
        return t.replace(
          /<script.*?<\/script>|<!--.*?-->|<style.*?<\/style>|<.*?>/g,
          ""
        );
      },
      abs: Jr,
      atLeast: Yr,
      atMost: $r,
      ceil: Gr,
      dividedBy: function (t, e) {
        return t / e;
      },
      floor: Qr,
      minus: function (t, e) {
        return t - e;
      },
      modulo: function (t, e) {
        return t % e;
      },
      times: function (t, e) {
        return t * e;
      },
      round: function (t, e) {
        void 0 === e && (e = 0);
        var r = Math.pow(10, e);
        return Math.round(t * r) / r;
      },
      plus: function (t, e) {
        return Number(t) + Number(e);
      },
      sortNatural: function (t, e) {
        return t && t.sort
          ? void 0 !== e
            ? gt([], mt(t), !1).sort(function (t, r) {
                return Dt(t[e], r[e]);
              })
            : gt([], mt(t), !1).sort(Dt)
          : [];
      },
      urlDecode: function (t) {
        return t.split("+").map(decodeURIComponent).join(" ");
      },
      urlEncode: function (t) {
        return t.split(" ").map(encodeURIComponent).join("+");
      },
      join: function (t, e) {
        return t.join(void 0 === e ? " " : e);
      },
      last: function (t) {
        return Et(t) ? Lt(t) : "";
      },
      first: function (t) {
        return Et(t) ? t[0] : "";
      },
      reverse: function (t) {
        return gt([], mt(t), !1).reverse();
      },
      sort: function (t, e) {
        var r = this,
          n = function (t) {
            return e ? r.context.getFromScope(t, e.split(".")) : t;
          };
        return yr(t).sort(function (t, e) {
          return (t = n(t)) < (e = n(e)) ? -1 : t > e ? 1 : 0;
        });
      },
      size: function (t) {
        return (t && t.length) || 0;
      },
      map: function (t, e) {
        var r = this;
        return yr(t).map(function (t) {
          return r.context.getFromScope(t, e.split("."));
        });
      },
      compact: function (t) {
        return yr(t).filter(function (t) {
          return !qt(t);
        });
      },
      concat: function (t, e) {
        return yr(t).concat(e);
      },
      slice: function (t, e, r) {
        return (
          void 0 === r && (r = 1),
          (e = e < 0 ? t.length + e : e),
          t.slice(e, e + r)
        );
      },
      where: function (t, e, r) {
        var n = this;
        return yr(t).filter(function (t) {
          var i = n.context.getFromScope(t, String(e).split("."));
          return void 0 === r
            ? Ht(i, n.context)
            : zt(r)
            ? r.equals(i)
            : i === r;
        });
      },
      uniq: function (t) {
        var e = {};
        return (t || []).filter(function (t) {
          return !e.hasOwnProperty(String(t)) && ((e[String(t)] = !0), !0);
        });
      },
      date: function (t, e) {
        var r,
          n = this.context.opts;
        return (function (t) {
          return (t instanceof Date || t instanceof hn) && !isNaN(t.getTime());
        })(
          (r =
            "now" === t || "today" === t
              ? new Date()
              : Ot(t)
              ? new Date(1e3 * t)
              : _t(t)
              ? /^\d+$/.test(t)
                ? new Date(1e3 * +t)
                : n.preserveTimezones
                ? hn.createDateFixedToTimezone(t)
                : new Date(t)
              : t)
        )
          ? (n.hasOwnProperty("timezoneOffset") &&
              (r = new hn(r, n.timezoneOffset)),
            (function (t, e) {
              for (var r, n = "", i = e; (r = Xr.exec(i)); )
                (n += i.slice(0, r.index)),
                  (i = i.slice(r.index + r[0].length)),
                  (n += pn(t, r));
              return n + i;
            })(r, e))
          : t;
      },
      Default: function (t, e) {
        for (var r = [], n = 2; n < arguments.length; n++)
          r[n - 2] = arguments[n];
        return Et(t) || _t(t)
          ? t.length
            ? t
            : e
          : (!1 !== (t = Tt(t)) || !new Map(r).get("allow_false")) &&
              (Wt(t, this.context) ? e : t);
      },
      json: function (t) {
        return JSON.stringify(t);
      },
      append: function (t, e) {
        return (
          oe(2 === arguments.length, "append expect 2 arguments"), xt(t) + xt(e)
        );
      },
      prepend: function (t, e) {
        return (
          oe(2 === arguments.length, "prepend expect 2 arguments"),
          xt(e) + xt(t)
        );
      },
      lstrip: function (t) {
        return xt(t).replace(/^\s+/, "");
      },
      downcase: function (t) {
        return xt(t).toLowerCase();
      },
      upcase: function (t) {
        return xt(t).toUpperCase();
      },
      remove: function (t, e) {
        return xt(t).split(String(e)).join("");
      },
      removeFirst: function (t, e) {
        return xt(t).replace(String(e), "");
      },
      rstrip: function (t) {
        return xt(t).replace(/\s+$/, "");
      },
      split: function (t, e) {
        return xt(t).split(String(e));
      },
      strip: function (t) {
        return xt(t).trim();
      },
      stripNewlines: function (t) {
        return xt(t).replace(/\n/g, "");
      },
      capitalize: function (t) {
        return (t = xt(t)).charAt(0).toUpperCase() + t.slice(1).toLowerCase();
      },
      replace: function (t, e, r) {
        return xt(t).split(String(e)).join(r);
      },
      replaceFirst: function (t, e, r) {
        return xt(t).replace(String(e), r);
      },
      truncate: function (t, e, r) {
        return (
          void 0 === e && (e = 50),
          void 0 === r && (r = "..."),
          (t = xt(t)).length <= e ? t : t.substr(0, e - r.length) + r
        );
      },
      truncatewords: function (t, e, r) {
        void 0 === e && (e = 15), void 0 === r && (r = "...");
        var n = t.split(/\s+/),
          i = n.slice(0, e).join(" ");
        return n.length >= e && (i += r), i;
      },
    }),
    mn = (function () {
      function t() {
        this.impls = {};
      }
      return (
        (t.prototype.get = function (t) {
          var e = this.impls[t];
          return (
            oe(e, function () {
              return 'tag "'.concat(t, '" not found');
            }),
            e
          );
        }),
        (t.prototype.set = function (t, e) {
          this.impls[t] = e;
        }),
        t
      );
    })(),
    gn = (function () {
      function t(t, e) {
        (this.strictFilters = t), (this.liquid = e), (this.impls = {});
      }
      return (
        (t.prototype.get = function (t) {
          var e = this.impls[t];
          return (
            oe(e || !this.strictFilters, function () {
              return "undefined filter: ".concat(t);
            }),
            e
          );
        }),
        (t.prototype.set = function (t, e) {
          this.impls[t] = e;
        }),
        (t.prototype.create = function (t, e) {
          return new lr(t, this.get(t), e, this.liquid);
        }),
        t
      );
    })(),
    yn = (function () {
      function t(t) {
        var e = this;
        void 0 === t && (t = {}),
          (this.options = (function (t) {
            if (
              (t.hasOwnProperty("operators") &&
                (t.operatorsTrie = Yt(t.operators)),
              t.hasOwnProperty("root") &&
                (t.hasOwnProperty("partials") || (t.partials = t.root),
                t.hasOwnProperty("layouts") || (t.layouts = t.root)),
              t.hasOwnProperty("cache"))
            ) {
              var e = void 0;
              (e =
                "number" == typeof t.cache
                  ? t.cache > 0
                    ? new It(t.cache)
                    : void 0
                  : "object" == typeof t.cache
                  ? t.cache
                  : t.cache
                  ? new It(1024)
                  : void 0),
                (t.cache = e);
            }
            return (
              !(t = ft(
                ft(ft({}, $t), t.jekyllInclude ? { dynamicPartials: !1 } : {}),
                t
              )).fs.dirname &&
                t.relativeReference &&
                (console.warn(
                  "[LiquidJS] `fs.dirname` is required for relativeReference, set relativeReference to `false` to suppress this warning, or provide implementation for `fs.dirname`"
                ),
                (t.relativeReference = !1)),
              (t.root = Gt(t.root)),
              (t.partials = Gt(t.partials)),
              (t.layouts = Gt(t.layouts)),
              t
            );
          })(t)),
          (this.parser = new vr(this)),
          (this.renderer = new me()),
          (this.filters = new gn(this.options.strictFilters, this)),
          (this.tags = new mn()),
          At(zr, function (t, r) {
            return e.registerTag(Rt(r), t);
          }),
          At(vn, function (t, r) {
            return e.registerFilter(Rt(r), t);
          });
      }
      return (
        (t.prototype.parse = function (t, e) {
          return this.parser.parse(t, e);
        }),
        (t.prototype._render = function (t, e, r) {
          var n = new ie(e, this.options, r);
          return this.renderer.renderTemplates(t, n);
        }),
        (t.prototype.render = function (t, e, r) {
          return dt(this, void 0, void 0, function () {
            return ht(this, function (n) {
              return [2, fe(this._render(t, e, ft(ft({}, r), { sync: !1 })))];
            });
          });
        }),
        (t.prototype.renderSync = function (t, e, r) {
          return de(this._render(t, e, ft(ft({}, r), { sync: !0 })));
        }),
        (t.prototype.renderToNodeStream = function (t, e, r) {
          void 0 === r && (r = {});
          var n = new ie(e, this.options, r);
          return this.renderer.renderTemplatesToNodeStream(t, n);
        }),
        (t.prototype._parseAndRender = function (t, e, r) {
          var n = this.parse(t);
          return this._render(n, e, r);
        }),
        (t.prototype.parseAndRender = function (t, e, r) {
          return dt(this, void 0, void 0, function () {
            return ht(this, function (n) {
              return [
                2,
                fe(this._parseAndRender(t, e, ft(ft({}, r), { sync: !1 }))),
              ];
            });
          });
        }),
        (t.prototype.parseAndRenderSync = function (t, e, r) {
          return de(this._parseAndRender(t, e, ft(ft({}, r), { sync: !0 })));
        }),
        (t.prototype._parsePartialFile = function (t, e, r) {
          return this.parser.parseFile(t, e, ne.Partials, r);
        }),
        (t.prototype._parseLayoutFile = function (t, e, r) {
          return this.parser.parseFile(t, e, ne.Layouts, r);
        }),
        (t.prototype.parseFile = function (t) {
          return dt(this, void 0, void 0, function () {
            return ht(this, function (e) {
              return [2, fe(this.parser.parseFile(t, !1))];
            });
          });
        }),
        (t.prototype.parseFileSync = function (t) {
          return de(this.parser.parseFile(t, !0));
        }),
        (t.prototype.renderFile = function (t, e, r) {
          return dt(this, void 0, void 0, function () {
            var n;
            return ht(this, function (i) {
              switch (i.label) {
                case 0:
                  return [4, this.parseFile(t)];
                case 1:
                  return (n = i.sent()), [2, this.render(n, e, r)];
              }
            });
          });
        }),
        (t.prototype.renderFileSync = function (t, e, r) {
          var n = this.parseFileSync(t);
          return this.renderSync(n, e, r);
        }),
        (t.prototype.renderFileToNodeStream = function (t, e, r) {
          return dt(this, void 0, void 0, function () {
            var n;
            return ht(this, function (i) {
              switch (i.label) {
                case 0:
                  return [4, this.parseFile(t)];
                case 1:
                  return (n = i.sent()), [2, this.renderToNodeStream(n, e, r)];
              }
            });
          });
        }),
        (t.prototype._evalValue = function (t, e) {
          return new pr(t, this).value(e, !1);
        }),
        (t.prototype.evalValue = function (t, e) {
          return dt(this, void 0, void 0, function () {
            return ht(this, function (r) {
              return [2, fe(this._evalValue(t, e))];
            });
          });
        }),
        (t.prototype.evalValueSync = function (t, e) {
          return de(this._evalValue(t, e));
        }),
        (t.prototype.registerFilter = function (t, e) {
          this.filters.set(t, e);
        }),
        (t.prototype.registerTag = function (t, e) {
          this.tags.set(t, e);
        }),
        (t.prototype.plugin = function (e) {
          return e.call(this, t);
        }),
        (t.prototype.express = function () {
          var t = this,
            e = !0;
          return function (r, n, i) {
            var o, a, s;
            if (e) {
              e = !1;
              var u = Gt(this.root);
              (o = t.options.root).unshift.apply(o, gt([], mt(u), !1)),
                (a = t.options.layouts).unshift.apply(a, gt([], mt(u), !1)),
                (s = t.options.partials).unshift.apply(s, gt([], mt(u), !1));
            }
            t.renderFile(r, n).then(function (t) {
              return i(null, t);
            }, i);
          };
        }),
        t
      );
    })();
  function wn(t, e) {
    var r = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(t);
      e &&
        (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })),
        r.push.apply(r, n);
    }
    return r;
  }
  function bn(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = null != arguments[e] ? arguments[e] : {};
      e % 2
        ? wn(Object(r), !0).forEach(function (e) {
            _n(t, e, r[e]);
          })
        : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r))
        : wn(Object(r)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
          });
    }
    return t;
  }
  function _n(t, e, r) {
    return (
      e in t
        ? Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (t[e] = r),
      t
    );
  }
  function Sn(t) {
    return (
      (function (t) {
        if (Array.isArray(t)) return xn(t);
      })(t) ||
      (function (t) {
        if (
          ("undefined" != typeof Symbol && null != t[Symbol.iterator]) ||
          null != t["@@iterator"]
        )
          return Array.from(t);
      })(t) ||
      (function (t, e) {
        if (!t) return;
        if ("string" == typeof t) return xn(t, e);
        var r = Object.prototype.toString.call(t).slice(8, -1);
        "Object" === r && t.constructor && (r = t.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(t);
        if (
          "Arguments" === r ||
          /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
        )
          return xn(t, e);
      })(t) ||
      (function () {
        throw new TypeError(
          "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
        );
      })()
    );
  }
  function xn(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
    return n;
  }
  var Tn,
    On = {
      currentTheme: "",
      currentOptionSelected: [],
      currentVariantId: null,
      variantsAvailable: [],
      formSelector: null,
      selectors: {
        singleOptionSelector:
          "select.single-option-selector,.options-selection__input-select,.product__variant,.select-wrapper>select,.form__input--select,.product-option-select select,.selector-wrapper select,.form-element-select select,.product-form__option-select,.pf-element select,select.option-selector,.product-details__option-wrapper select,.product-form__input select,select.pf-variant-select,select.product-form__input,select.form-control,select.product-option.custom-select,.variant-input-wrap>select,select.product-option-value-item,#product-variants>select#product-selectors",
        radioSelectors:
          '.option-selector__btns input[type="radio"].opt-btn.js-option, input[type="radio"].single-option-selector__radio,input[type="radio"].variant-input,input.form-check-input[type="radio"],input.product-variant__input[type="radio"],input.product-form__single-selector[type="radio"],.radio__fieldset input[type="radio"],input.swatch__input[type="radio"],.swatch-element input[type="radio"],input.option-value-input[type="radio"],input.radios--input[type="radio"],input.single-option-selector[type="radio"],.form-swatch-item input[type="radio"],.product-options input[type="radio"],.single-option-radio input[type="radio"],.product-form__input input[type="radio"],.pf-variant-radio input[type="radio"],input.single-option-selector-product-template[type="radio"],.options-selection__option-values input[type="radio"],.swatch__option input[type="radio"],input.ColorSwatch__Radio[type="radio"],.variant-input input[type="radio"],input.SizeSwatch__Radio[type="radio"],.radio-btn input[type="radio"]',
        customSelectors:
          "input.disclosure--input,.js-option.active,.product__chip,.Popover__Value,.popout-list__option,.clickyboxes a,li.nt-swatch.swatch_pr_item",
        hideElements:
          ".selector-wrapper,.radio-wrapper,fieldset,.options-selection__select-wrapper,.disclosure--root,.product-options[data-section-name],.js-enabled.product-form__option,.product-form__select,.product-option,.product-option-select,.product-variant,.variant-wrapper,.product-form__variants,.js-enabled,.swatch.selectors,.swatch_options,.ProductForm__Variants,.form-element-wrapper,.variant-group,.swatch,.product-single__swatches,.product-form--variants,.product__variants,.product-swatches,.product-options .option,.product-options,.swatches__container,.product-form-grid-select,.product-details__option-wrapper",
      },
      isArrayEqual: function (t, e) {
        if (t.length !== e.length) return !1;
        for (var r = 0; r < t.length; r++) if (!e.includes(t[r])) return !1;
        return !0;
      },
      appendControl: function (t) {
        var e = this,
          r = new DOMParser(),
          n = document.querySelector(
            "#vario-product-variant-template"
          ).innerHTML,
          i = new yn();
        return (
          i.registerFilter("img_url", function (t, e, r) {
            if (!t) return "";
            r = r || !1;
            var n = t.split(".").pop(),
              i = t.lastIndexOf(n) - 1;
            return t.slice(0, i) + "_" + e + t.slice(i);
          }),
          new Promise(function (o, a) {
            var s = i.parse(n);
            i.render(s, {
              product: t,
              options_with_values: window.vario_options_with_values,
              varioSettings: window.varioSettings,
            }).then(function (t) {
              var n = r
                .parseFromString(t, "text/html")
                .querySelector(".vario-all-variant-wrapper");
              if (
                document.querySelector &&
                "luv-cobeauty.myshopify.com" == Shopify.shop
              )
                return (
                  document
                    .querySelector(
                      'form[action*="/cart/add"] .grid--uniform.product-single__addtocart'
                    )
                    .parentNode.insertBefore(
                      n,
                      document.querySelector(
                        'form[action*="/cart/add"] .grid--uniform.product-single__addtocart'
                      )
                    ),
                  void o(t)
                );
              if ("moonkie-shop.myshopify.com" == Shopify.shop)
                return (
                  document
                    .querySelector(
                      'form[action*="/cart/add"] .product-single__variants'
                    )
                    .parentNode.insertBefore(
                      n,
                      document.querySelector(
                        'form[action*="/cart/add"] .product-single__variants'
                      )
                    ),
                  void o(t)
                );
              if ("maxxofertas1.myshopify.com" == Shopify.shop)
                return (
                  document
                    .querySelector('form[action*="/cart/add"]')
                    .parentNode.insertBefore(
                      n,
                      document.querySelector('form[action*="/cart/add"]')
                    ),
                  void o(t)
                );
              if ("mariobemer.myshopify.com" == Shopify.shop)
                return (
                  document
                    .querySelector(
                      'form[action*="/cart/add"] .ProductMeta__ShareButtons'
                    )
                    .parentNode.insertBefore(
                      n,
                      document.querySelector(
                        'form[action*="/cart/add"] .ProductMeta__ShareButtons'
                      )
                    ),
                  void o(t)
                );
              if ("shop-junto.myshopify.com" == Shopify.shop)
                return (
                  document
                    .querySelector(
                      'form[action*="/cart/add"] .single_product__options'
                    )
                    .prepend(n),
                  void o(t)
                );
              if ("emi-theory.myshopify.com" == Shopify.shop)
                return (
                  document
                    .querySelector(
                      'form[action*="/cart/add"] .product-form__variants'
                    )
                    .parentNode.insertBefore(
                      n,
                      document.querySelector(
                        'form[action*="/cart/add"] .product-form__variants'
                      )
                    ),
                  void o(t)
                );
              if ("helrym.myshopify.com" == Shopify.shop)
                return (
                  document
                    .querySelector(
                      'form[action*="/cart/add"] .product-description'
                    )
                    .parentNode.insertBefore(
                      n,
                      document.querySelector(
                        'form[action*="/cart/add"] .product-description'
                      )
                    ),
                  void o(t)
                );
              if ("lawrence-russel.myshopify.com" == Shopify.shop)
                return (
                  document
                    .querySelector(
                      'form[action*="/cart/add"] .product-info .product-single__variants'
                    )
                    .parentNode.insertBefore(
                      n,
                      document.querySelector(
                        'form[action*="/cart/add"] .product-info .product-single__variants'
                      )
                    ),
                  void o(t)
                );
              if ("jocafs-ab.myshopify.com" == Shopify.shop)
                return (
                  document
                    .querySelector(
                      'form[action*="/cart/add"] .product-swatches'
                    )
                    .parentNode.insertBefore(
                      n,
                      document.querySelector(
                        'form[action*="/cart/add"] .product-swatches'
                      )
                    ),
                  void o(t)
                );
              if ("dd-s-bridal-shop.myshopify.com" == Shopify.shop)
                return (
                  document
                    .querySelector(
                      'form[action*="/cart/add"] .product-form__controls-group'
                    )
                    .parentNode.insertBefore(
                      n,
                      document.querySelector(
                        'form[action*="/cart/add"] .product-form__controls-group'
                      )
                    ),
                  void o(t)
                );
              if ("tickingdepot.myshopify.com" == Shopify.shop)
                return (
                  document.querySelector(
                    'form[action*="/cart/add"] .product-details__options'
                  ) &&
                    document
                      .querySelector(
                        'form[action*="/cart/add"] .product-details__options'
                      )
                      .parentNode.insertBefore(
                        n,
                        document.querySelector(
                          'form[action*="/cart/add"] .product-details__options'
                        )
                      ),
                  void o(t)
                );
              if ("tkgky-nie.myshopify.com" == Shopify.shop)
                return (
                  document
                    .querySelector(
                      'form[action*="/cart/add"] .product-detail__quantity-row'
                    )
                    .parentNode.insertBefore(
                      n,
                      document.querySelector(
                        'form[action*="/cart/add"] .product-detail__quantity-row'
                      )
                    ),
                  void o(t)
                );
              if ("hello-sunny-day.myshopify.com" == Shopify.shop)
                return (
                  document
                    .querySelector(
                      'form[action*="/cart/add"] .original-selector'
                    )
                    .parentNode.insertBefore(
                      n,
                      document.querySelector(
                        'form[action*="/cart/add"] .original-selector'
                      )
                    ),
                  void o(t)
                );
              if ("db-custom-branding.myshopify.com" == Shopify.shop)
                return (
                  document
                    .querySelector(
                      'form[action*="/cart/add"] .product-form__variants'
                    )
                    .parentNode.insertBefore(
                      n,
                      document.querySelector(
                        'form[action*="/cart/add"] .product-form__variants'
                      )
                    ),
                  void o(t)
                );
              if ("amici-pelosetti-store.myshopify.com" == Shopify.shop)
                return (
                  document
                    .querySelector(
                      'form[action*="/cart/add"].product-single__form'
                    )
                    .parentNode.insertBefore(
                      n,
                      document.querySelector(
                        'form[action*="/cart/add"].product-single__form'
                      )
                    ),
                  void o(t)
                );
              if ("hawkins-woodshop.myshopify.com" == Shopify.shop)
                return (
                  document
                    .querySelector(
                      'form[action*="/cart/add"] .product-form__variants'
                    )
                    .parentNode.insertBefore(
                      n,
                      document.querySelector(
                        'form[action*="/cart/add"] .product-form__variants'
                      )
                    ),
                  void o(t)
                );
              if (
                "brightrsleep.myshopify.com" == Shopify.shop &&
                document.querySelector(
                  '[data-pf-type="ProductVariantSwatches"],[data-pf-type="ProductVariant"]'
                )
              )
                return (
                  document
                    .querySelector(
                      '[data-pf-type="ProductVariantSwatches"],[data-pf-type="ProductVariant"]'
                    )
                    .parentNode.insertBefore(
                      n,
                      document.querySelector(
                        '[data-pf-type="ProductVariantSwatches"],[data-pf-type="ProductVariant"]'
                      )
                    ),
                  void o(t)
                );
              if (
                "earth-eden-brand.myshopify.com" == Shopify.shop &&
                document.querySelector(".product-form-option")
              )
                return (
                  document
                    .querySelector(".product-form-option")
                    .parentNode.insertBefore(
                      n,
                      document.querySelector(".product-form-option")
                    ),
                  void o(t)
                );
              if (
                "linions.myshopify.com" == Shopify.shop &&
                document.querySelector(
                  ".product-single__variants.product-form__item"
                )
              )
                return (
                  document
                    .querySelector(
                      ".product-single__variants.product-form__item"
                    )
                    .parentNode.insertBefore(
                      n,
                      document.querySelector(
                        ".product-single__variants.product-form__item"
                      )
                    ),
                  void o(t)
                );
              if (
                "vilan-hotcutes.myshopify.com" == Shopify.shop &&
                document.querySelector(".product-swatches")
              )
                return (
                  document
                    .querySelector(".product-swatches")
                    .parentNode.insertBefore(
                      n,
                      document.querySelector(".product-swatches")
                    ),
                  void o(t)
                );
              if (
                "oppo-italia-store.myshopify.com" == Shopify.shop &&
                document.querySelector(".variants.clearfix")
              )
                return (
                  document
                    .querySelector(".variants.clearfix")
                    .parentNode.insertBefore(
                      n,
                      document.querySelector(".variants.clearfix")
                    ),
                  void o(t)
                );
              if (
                "clue22-com.myshopify.com" == Shopify.shop &&
                document.querySelector("div.product__text")
              )
                return (
                  document
                    .querySelector("div.product__text")
                    .parentNode.insertBefore(
                      n,
                      document.querySelector("div.product__text").nextSibling
                    ),
                  void o(t)
                );
              if (865 == Shopify.theme.theme_store_id)
                return (
                  document
                    .querySelector(
                      'form[action*="/cart/add"] .purchase-section'
                    )
                    .prepend(n),
                  void o(t)
                );
              if (855 == Shopify.theme.theme_store_id)
                return (
                  e.formSelector.insertBefore(
                    n,
                    e.formSelector.querySelector(".ProductForm__Variants")
                  ),
                  void o(t)
                );
              if (846 == Shopify.theme.theme_store_id)
                return (
                  e.formSelector
                    .querySelector(".product-details")
                    .insertBefore(
                      n,
                      e.formSelector.querySelector(".variant-group")
                    ),
                  void o(t)
                );
              if (window.__pagefly_setting__) {
                var i = document.querySelectorAll(
                  '[data-pf-type="ProductVariant"]'
                );
                if (
                  (i.length &&
                    i.forEach(function (t) {
                      t.parentNode.insertBefore(n, t);
                    }),
                  document.querySelector(".vario-variant-wrapper"))
                )
                  return void o(t);
              }
              document.querySelector('form[action*="/cart/add"]').prepend(n),
                o(t);
            });
          })
        );
      },
      getCurrentOptions: function () {
        if (this.formSelector) {
          var t = this.formSelector.querySelector(
            'select[name="id"], input[name="id"]'
          );
          if (t) {
            this.currentVariantId = t.value;
            var e = t.value,
              r = window.location.href.match(/\?variant=(\d+)$/);
            window.__pagefly_setting__ && r && r[1] != e && (e = r[1]);
            var n = seedGrowJSData.variants.find(function (t) {
              return t.id == e;
            });
            n && (this.currentOptionSelected = Sn(n.options));
          }
        }
      },
      generateTooltip: function () {
        var t = document.querySelectorAll(".vario-variant[data-v-tooltip]");
        t &&
          t.forEach(function (t) {
            var e = document.createElement("span");
            if ("name" === varioCustomizer.swatches.hover_effect) {
              e.classList.add("vario-variant-tip");
              e.appendChild(
                (function (t) {
                  return document.createTextNode(t);
                })(t.getAttribute("data-value"))
              );
            } else if ("zoom" === varioCustomizer.swatches.hover_effect) {
              e.classList.add("vario-variant-tip"),
                t.classList.add("vario-variant-zoom-tip");
              e.appendChild(
                (function (t) {
                  return document.createTextNode(t);
                })(t.getAttribute("data-value"))
              );
            } else if ("image" === varioCustomizer.swatches.hover_effect) {
              if (t.querySelector(".swatch-color")) {
                e.classList.add("vario-variant-tip");
                e.appendChild(
                  (function (t) {
                    return document.createTextNode(t);
                  })(t.getAttribute("data-value"))
                );
              } else {
                e.classList.add("vario-variant-img-tip");
                var r = t.querySelector(".swatch-image");
                if (r) {
                  var n = r.style.backgroundImage,
                    i = /\([\s\S]*\)/
                      .exec(n)[0]
                      .replaceAll(/_50x|_120x|_360x|\(|\)|\"/gi, "");
                  if (i) {
                    var o = document.createElement("img");
                    (o.width = 150),
                      (o.height = 150),
                      (o.alt = "swatch image"),
                      (o.src = i),
                      e.appendChild(o);
                  }
                  var a = document.createElement("span");
                  (a.innerText = t.getAttribute("data-value")),
                    e.appendChild(a);
                }
              }
            }
            document.body.appendChild(e);
            var s = 8;
            "zoom" === varioCustomizer.swatches.hover_effect && (s = 14);
            var u = ct(t, e, {
              modifiers: [{ name: "offset", options: { offset: [0, s] } }],
              placement:
                "undefined" != typeof vario_tip_placement
                  ? vario_tip_placement
                  : "top",
            });
            t.addEventListener("mouseenter", function () {
              e.setAttribute("data-tip-show", ""), u.update();
            }),
              t.addEventListener("mouseleave", function () {
                e.removeAttribute("data-tip-show");
              });
          });
      },
      triggerControlEvent: function (t, e) {
        var r = this,
          n = document.querySelectorAll(this.selectors.singleOptionSelector);
        if (n.length) {
          var i = Object.values(n).find(function (e) {
              return Object.values(e.options).find(function (e) {
                return e.value == t;
              });
            }),
            o = Object.values(n).filter(function (e) {
              return Object.values(e).find(function (e) {
                return e.value == t;
              });
            });
          o.length &&
            (1 == o.length
              ? i &&
                (i.value = t) &&
                i.dispatchEvent(new Event("change", { bubbles: !0 }))
              : o[0] &&
                (o[0].value = t) &&
                o[0].dispatchEvent(new Event("change", { bubbles: !0 }))),
            !i &&
              seedGrowJSData.variants.find(function (e) {
                if (r.isArrayEqual(e.options, r.currentOptionSelected)) {
                  var i = Object.values(n).find(function (r) {
                    return Object.values(r.options).find(function (r) {
                      return r.value == t || r.value == e.id;
                    });
                  });
                  i &&
                    (i.value = e.id) &&
                    i.dispatchEvent(new Event("change", { bubbles: !0 }));
                }
              });
        }
        var a = document.querySelectorAll(this.selectors.radioSelectors);
        if (a.length) {
          var s = Object.values(a).filter(function (e) {
            return e.value == t;
          });
          if (s.length)
            if (1 == s.length) s[0] && s[0].click();
            else {
              var u = s.find(function (t) {
                return (
                  t.dataset.index == "option".concat(e + 1) ||
                  t.dataset.optionPosition == e + 1
                );
              });
              u && u.click();
            }
          else
            seedGrowJSData.variants.forEach(function (t) {
              if (r.isArrayEqual(t.options, r.currentOptionSelected)) {
                var e = Object.values(a).find(function (e) {
                  return e.value == t.id;
                });
                e && e.click();
              }
            });
        }
        var c = document.querySelectorAll(this.selectors.customSelectors);
        c.length &&
          c.forEach(function (e) {
            e.parentNode.querySelector('[data-value="'.concat(t, '"]')) &&
              e.parentNode
                .querySelector('[data-value="'.concat(t, '"]'))
                .click(),
              e.parentNode.querySelector('[data-button="'.concat(t, '"]')) &&
                e.parentNode
                  .querySelector('[data-button="'.concat(t, '"]'))
                  .click(),
              e.parentNode.querySelector('[data-escape="'.concat(t, '"]')) &&
                e.parentNode
                  .querySelector('[data-escape="'.concat(t, '"]'))
                  .click();
          });
      },
      addControlEvents: function () {
        var t = this,
          e = document.querySelectorAll(".vario-variants");
        e.length &&
          e.forEach(function (e, r) {
            if ("SELECT" == e.nodeName)
              t.currentOptionSelected[r] &&
                ((e.value = t.currentOptionSelected[r]),
                Object.values(e.options).find(function (n) {
                  n.value == t.currentOptionSelected[r] &&
                    (n.selected = "selected"),
                    (e
                      .closest(".vario-variant-wrapper")
                      .querySelector(".vario-variant-selected").innerText =
                      t.currentOptionSelected[r]);
                }));
            else {
              var n = e.querySelectorAll(".vario-variant");
              n.length &&
                n.forEach(function (e) {
                  e.getAttribute("data-value") == t.currentOptionSelected[r] &&
                    (e.classList.add("sv_active"),
                    (e
                      .closest(".vario-variant-wrapper")
                      .querySelector(".vario-variant-selected").innerText =
                      t.currentOptionSelected[r]));
                });
            }
          }),
          document.body.addEventListener("change", function (t) {
            var e = t.target,
              r = parseInt(e.getAttribute("data-position"));
            e.classList.contains("vario-variants") &&
              ((e
                .closest(".vario-variant-wrapper")
                .querySelector(".vario-variant-selected").innerText = e.value),
              (On.currentOptionSelected[r] = e.value),
              On.triggerControlEvent(e.value, r),
              On.disableVariantNotAvailable());
          }),
          document.body.addEventListener("click", function (t) {
            var e = t.target.closest("li.vario-variant"),
              r = t.target.closest("ul.vario-variants");
            if (e) {
              var n = e.getAttribute("data-value"),
                i = parseInt(e.getAttribute("data-position"));
              e
                .closest(".vario-variant-wrapper")
                .querySelector(".vario-variant-selected").innerText = n;
              var o = r.querySelector(".sv_active");
              o && o.classList.remove("sv_active"),
                e.classList.add("sv_active"),
                (On.currentOptionSelected[i] = n),
                On.triggerControlEvent(n, i),
                On.disableVariantNotAvailable();
            }
          });
      },
      init: function () {
        var t = this,
          e = document.querySelectorAll('form[action*="/cart/add"]');
        e.length > 1
          ? ((this.formSelector = document.querySelector(
              'form[action*="/cart/add"][data-product-form]'
            )),
            !this.formSelector && (this.formSelector = e[0]))
          : (this.formSelector = e[0]);
        var r = JSON.parse(
          document.querySelector("#vario-product-json").innerHTML
        );
        (window.seedGrowJSData = r),
          this.getAvailableVariantOptions(r.variants),
          varioCustomizer.sold_out.show_sold_out_variants &&
            this.getCurrentOptions(),
          this.onVariantInFormChange(),
          this.appendControl(r).then(function (e) {
            t.addControlEvents(),
              varioCustomizer.sold_out.show_sold_out_variants
                ? t.disableVariantNotAvailable()
                : "automatic" === varioCustomizer.sold_out.hide_style &&
                  (t.getCurrentOptions(), t.disableVariantNotAvailable()),
              t.generateTooltip();
          });
      },
      setDefaultOptions: function () {
        (this.currentOptionSelected.length &&
          -1 === this.currentOptionSelected.indexOf("not-selected")) ||
          document.querySelectorAll(".vario-variants").forEach(function (t) {
            t.querySelector(".vario-variant").click();
          });
      },
      getAvailableVariantOptions: function (t) {
        var e = this;
        t.forEach(function (t) {
          t.available && e.variantsAvailable.push(Sn(t.options));
        });
      },
      hideFormElements: function () {
        document
          .querySelectorAll(this.selectors.hideElements)
          .forEach(function (t) {
            return (t.style.display = "none");
          });
      },
      disableVariantNotAvailable: function () {
        var t = this,
          e = document.querySelectorAll(".vario-variants");
        (!varioCustomizer.sold_out.show_sold_out_variants ||
          (this.currentOptionSelected.length &&
            seedGrowJSData.options.length ===
              this.currentOptionSelected.length)) &&
          e.forEach(function (e, r) {
            e.querySelectorAll(".vario-variant").forEach(function (e) {
              var r = e.getAttribute("data-value"),
                n = e.getAttribute("data-position"),
                i = (e.getAttribute("data-option"), []);
              if (
                (((i = Sn(t.currentOptionSelected))[n] = r),
                t.variantsAvailable.find(function (e) {
                  return t.isArrayEqual(e, i);
                }))
              )
                e.classList.remove(
                  "vario-disabled",
                  "vario-disabled-grayscale",
                  "vario-disabled-hidden"
                );
              else if (varioCustomizer.sold_out.show_sold_out_variants)
                "gray-out" === varioCustomizer.sold_out.style
                  ? e.classList.add("vario-disabled-grayscale")
                  : "cross" === varioCustomizer.sold_out.style &&
                    e.classList.add("vario-disabled");
              else {
                if (
                  !varioCustomizer.sold_out.show_sold_out_variants &&
                  t.currentOptionSelected[n] === r
                )
                  return;
                e.classList.add("vario-disabled-hidden");
              }
            });
          });
      },
      triggerSelfControl: function (t, e) {
        var r = document.querySelector(
          'select.vario-variants[data-position="'.concat(e, '"]')
        );
        r &&
          (function (t) {
            throw new TypeError('"' + t + '" is read-only');
          })("varioSelect") &&
          r.dispatchEvent(new Event("change", { bubbles: !0 }));
        var n = document.querySelector(
          '.vario-variant[data-value="'
            .concat(t, '"][data-position="')
            .concat(e, '"]')
        );
        n && n.click();
      },
      onVariantInFormChange: function () {
        var t = this,
          e = this.formSelector.querySelector(
            'select[name="id"], input[name="id"]'
          );
        e &&
          e.addEventListener("change", function (e) {
            t.currentVariantId &&
              t.currentVariantId != e.target.value &&
              (t.getCurrentOptions(),
              t.currentOptionSelected.forEach(function (e, r) {
                t.triggerSelfControl(e, r);
              }),
              (t.currentVariantId = null));
          });
      },
    },
    kn = {
      productSelectors: [],
      optionSelectors: [],
      collectionProducts: [],
      priceRegularSelectors:
        ".product-grid-item__content > p,.price__regular .price-item--regular,.grid-product__price,.product-item--price>span>small[aria-hidden=true],.price__sale .price-item--sale,.card__price,.grid-link__meta,.product-thumbnail__header .product__price,.product__prices,.product-item__price-wrapper,.product-card__price,.product-price .theme-money,.product-thumbnail__price,.price .amount.theme-money,.product-item__price-list .price,.ProductItem__Price.Price,.pricing .price,.product-grid--price .money,#CollectionProductGrid .money",
      priceCompareSelectors:
        ".price__sale .price-item--sale, .price__compare .price-item--regular,.product-item--price s small,.on-sale .sale-tag,.grid-product__on-sale",
      productImgSelectors:
        ".product-card a.product-card__image, .product-list-item-thumbnail > a,.grid-view-item__image-wrapper, .product-grid-item__image, .collection-template .product-index .prod-image .box-ratio, .collection-image--zoom-effect .grid__image,.ProductItem__ImageWrapper.ProductItem__ImageWrapper--withAlternateImage,.product-card__image-wrapper,.grid-product__image-link,.product-grid-image,.card__image-wrapper,.product__img-wrapper,.product__image-wrapper,.product-item__image-wrapper,.card--product .media, .product-thumbnail__media,.grid-product__image-mask .image-wrap,.rimage-wrapper,.product-image__wrapper,.ProductItem__ImageWrapper,.image-container-position,.card__media .media,.grid-view-item-image,.featured-collection__image",
      productImgWrapper:
        ".product-item--vertical, .card-wrapper, .product-index, .product-grid-item, article.product-list-item",
      moneyFormat: null,
      init: function () {
        var t = this;
        if (
          ((this.moneyFormat = this.getCurrentMoneyFormat()),
          (this.productSelectors = document.querySelectorAll(
            ".vario-collecion-product-tml"
          )),
          (this.optionSelectors = document.querySelectorAll(
            ".vario-collecion-product-options-tml"
          )),
          this.productSelectors.length && this.optionSelectors.length)
        ) {
          var e = this.productSelectors.length;
          this.productSelectors.forEach(function (r, n) {
            var i = JSON.parse(r.innerHTML),
              o = JSON.parse(t.optionSelectors[n].innerHTML);
            t.appendControl(r, i, o).then(function (o) {
              t.addControlEvents(r, n),
                t.collectionProducts.push(
                  bn(
                    bn({}, i),
                    {},
                    {
                      currentOptionSelected: [],
                      variantsAvailable: t.getAvailableVariantOptions(
                        i.variants
                      ),
                    }
                  )
                ),
                n === e - 1 && t.generateTooltip();
            });
          });
        }
      },
      generateTooltip: function () {
        var t = document.querySelectorAll(".vario-variant[data-v-tooltip]");
        t &&
          t.forEach(function (t) {
            var e = document.createElement("span");
            if ("name" === varioCustomizer.swatches.hover_effect) {
              e.classList.add("vario-variant-tip");
              e.appendChild(
                (function (t) {
                  return document.createTextNode(t);
                })(t.getAttribute("data-value"))
              );
            } else if ("zoom" === varioCustomizer.swatches.hover_effect) {
              e.classList.add("vario-variant-tip"),
                t.classList.add("vario-variant-zoom-tip");
              e.appendChild(
                (function (t) {
                  return document.createTextNode(t);
                })(t.getAttribute("data-value"))
              );
            } else if ("image" === varioCustomizer.swatches.hover_effect) {
              if (t.querySelector(".swatch-color")) {
                e.classList.add("vario-variant-tip");
                e.appendChild(
                  (function (t) {
                    return document.createTextNode(t);
                  })(t.getAttribute("data-value"))
                );
              } else {
                e.classList.add("vario-variant-img-tip");
                var r = t.querySelector(".swatch-image");
                if (r) {
                  var n = r.style.backgroundImage,
                    i = /\([\s\S]*\)/
                      .exec(n)[0]
                      .replaceAll(/_50x|_120x|_360x|\(|\)|\"/gi, "");
                  if (i) {
                    var o = document.createElement("img");
                    (o.width = 150),
                      (o.height = 150),
                      (o.alt = "swatch image"),
                      (o.src = i),
                      e.appendChild(o);
                  }
                  var a = document.createElement("span");
                  (a.innerText = t.getAttribute("data-value")),
                    e.appendChild(a);
                }
              }
            }
            document.body.appendChild(e);
            var s = 8;
            "zoom" === varioCustomizer.swatches.hover_effect && (s = 14);
            var u = ct(t, e, {
              modifiers: [{ name: "offset", options: { offset: [0, s] } }],
              placement:
                "undefined" != typeof vario_tip_placement
                  ? vario_tip_placement
                  : "top",
            });
            t.addEventListener("mouseenter", function () {
              e.setAttribute("data-tip-show", ""), u.update();
            }),
              t.addEventListener("mouseleave", function () {
                e.removeAttribute("data-tip-show");
              });
          });
      },
      getCurrentMoneyFormat: function () {
        var t, e, r, n, i, o, a, s, u, c, l, p, f, d, h;
        return null !== (t = window) && void 0 !== t && t.moneyFormat
          ? window.moneyFormat
          : null !== (e = window) &&
            void 0 !== e &&
            null !== (r = e.theme) &&
            void 0 !== r &&
            r.moneyFormat
          ? theme.moneyFormat
          : null !== (n = window) &&
            void 0 !== n &&
            null !== (i = n.theme) &&
            void 0 !== i &&
            null !== (o = i.settings) &&
            void 0 !== o &&
            o.moneyFormat
          ? theme.settings.moneyFormat
          : null !== (a = window) &&
            void 0 !== a &&
            null !== (s = a.theme) &&
            void 0 !== s &&
            s.money_format
          ? theme.money_format
          : null !== (u = window) &&
            void 0 !== u &&
            null !== (c = u.theme) &&
            void 0 !== c &&
            null !== (l = c.shop) &&
            void 0 !== l &&
            l.money_format
          ? theme.shop.money_format
          : null !== (p = window) &&
            void 0 !== p &&
            null !== (f = p.wetheme) &&
            void 0 !== f &&
            f.moneyFormat
          ? wetheme.moneyFormat
          : null !== (d = window) &&
            void 0 !== d &&
            null !== (h = d.StyleHatch) &&
            void 0 !== h &&
            h.currencyFormat
          ? StyleHatch.currencyFormat
          : window.VarioCurrencyFormat;
      },
      formatMoney: function (t, e) {
        "string" == typeof t && (t = t.replace(".", ""));
        var r = "",
          n = /\{\{\s*(\w+)\s*\}\}/,
          i = e || this.moneyFormat;
        function o(t, e) {
          return void 0 === t ? e : t;
        }
        function a(t, e, r, n) {
          if (
            ((e = o(e, 2)),
            (r = o(r, ",")),
            (n = o(n, ".")),
            isNaN(t) || null == t)
          )
            return 0;
          var i = (t = (t / 100).toFixed(e)).split(".");
          return (
            i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + r) +
            (i[1] ? n + i[1] : "")
          );
        }
        switch (i.match(n)[1]) {
          case "amount":
            r = a(t, 2);
            break;
          case "amount_no_decimals":
            r = a(t, 0);
            break;
          case "amount_with_apostrophe_separator":
            r = a(t, 2, "'", ".");
            break;
          case "amount_with_comma_separator":
            r = a(t, 2, ".", ",");
            break;
          case "amount_no_decimals_with_comma_separator":
            r = a(t, 0, ".", ",");
            break;
          case "amount_with_dot_separator":
            r = a(t, 2, ",", ".");
        }
        return i.replace(n, r);
      },
      appendControl: function (t, e, r) {
        var n = new DOMParser(),
          i = document.querySelector(
            "#vario-product-variant-template"
          ).innerHTML,
          o = new yn();
        return (
          o.registerFilter("img_url", function (t, e, r) {
            if (!t) return "";
            r = r || !1;
            var n = t.split(".").pop(),
              i = t.lastIndexOf(n) - 1;
            return t.slice(0, i) + "_" + e + t.slice(i);
          }),
          new Promise(function (a, s) {
            var u,
              c,
              l,
              p = o.parse(i);
            o.render(p, {
              product: e,
              options_with_values: r,
              varioSettings: window.varioSettings,
              page_type_collection: !(
                null === (u = window) ||
                void 0 === u ||
                null === (c = u.meta) ||
                void 0 === c ||
                null === (l = c.page) ||
                void 0 === l ||
                !l.pageType ||
                "collection" != window.meta.page.pageType
              ),
            }).then(function (e) {
              var r = n
                .parseFromString(e, "text/html")
                .querySelector(".vario-all-variant-wrapper");
              t.parentNode.insertBefore(r, t), a(e);
            });
          })
        );
      },
      addControlEvents: function (t, e) {
        var r = this,
          n = t.parentNode.querySelectorAll(".vario-variants");
        n.length &&
          n.forEach(function (i, o) {
            if ("SELECT" == i.nodeName)
              i.addEventListener("change", function (o) {
                var a = i.getAttribute("data-position");
                (i
                  .closest(".vario-variant-wrapper")
                  .querySelector(".vario-variant-selected").innerText =
                  o.target.value),
                  (r.collectionProducts[e].currentOptionSelected[a] =
                    o.target.value),
                  r.triggerHiddenVariant(t, e),
                  r.changePrice(t, e),
                  r.disableVariantNotAvailable(n, e);
              });
            else {
              var a = i.querySelectorAll(".vario-variant");
              a.length &&
                a.forEach(function (o) {
                  o.addEventListener("click", function (a) {
                    if (o.classList.contains("vario-plus-btn")) {
                      var s = o.getAttribute("data-action");
                      if ("link_product_page" == s) {
                        var u = o.getAttribute("data-handle");
                        window.location = "/products/" + u;
                      } else if ("show_swatches" == s) {
                        i.querySelectorAll(".vario-variant").forEach(function (
                          t
                        ) {
                          t.classList.contains("vario-plus-btn")
                            ? t.classList.add("vario-pl-hidden")
                            : t.classList.contains("vario-pl-hidden") &&
                              t.classList.remove("vario-pl-hidden");
                        });
                      }
                    } else if (
                      "undefined" != typeof vario_variant_action &&
                      "link_product_page" == vario_variant_action
                    ) {
                      var c = o.getAttribute("data-handle");
                      window.location = "/products/" + c;
                    } else {
                      var l = o.getAttribute("data-value"),
                        p = o.getAttribute("data-position");
                      o
                        .closest(".vario-variant-wrapper")
                        .querySelector(".vario-variant-selected").innerText = l;
                      var f = i.querySelector(".sv_active");
                      f && f.classList.remove("sv_active"),
                        o.classList.add("sv_active"),
                        (r.collectionProducts[e].currentOptionSelected[p] = l),
                        r.triggerHiddenVariant(t, e),
                        r.changePrice(t, e),
                        r.disableVariantNotAvailable(n, e),
                        document
                          .querySelector("body")
                          .classList.add("vario_clicked");
                    }
                  });
                });
            }
          });
      },
      triggerHiddenVariant: function (t, e) {
        var r = this,
          n = t.parentNode.querySelectorAll(
            ".vario-variant-wrapper.vario-hidden .vario-variants"
          );
        n.length &&
          n.forEach(function (t) {
            if ("SELECT" == t.nodeName) {
              var n = t.getAttribute("data-position"),
                i = t.firstElementChild.value;
              r.collectionProducts[e].currentOptionSelected[n] = i;
            } else {
              var o = t.firstElementChild.getAttribute("data-position"),
                a = t.firstElementChild.getAttribute("data-value");
              r.collectionProducts[e].currentOptionSelected[o] = a;
            }
          });
      },
      changeImgUrlSize: function (t, e) {
        if (!t) return "";
        var r = t.split(".").pop(),
          n = t.lastIndexOf(r) - 1;
        return t.slice(0, n) + "_" + e + t.slice(n);
      },
      changeImage: function (t, e) {
        var r = t.parentNode.querySelector(this.productImgSelectors);
        if (r) r = r.querySelector("img");
        else {
          var n = t
            .closest(this.productImgWrapper)
            .querySelector(this.productImgSelectors);
          n && (r = n.querySelector("img"));
        }
        r &&
          e.featured_image &&
          ((r.dataset.srcset = this.changeImgUrlSize(
            e.featured_image.src,
            varioCustomizer.collection.image_size + "x"
          )),
          (r.src = this.changeImgUrlSize(
            e.featured_image.src,
            varioCustomizer.collection.image_size + "x"
          )),
          (r.srcset = this.changeImgUrlSize(
            e.featured_image.src,
            varioCustomizer.collection.image_size + "x"
          )));
      },
      changePrice: function (t, e) {
        var r = this.collectionProducts[e].variants,
          n = this.collectionProducts[e].currentOptionSelected,
          i = r.find(function (t) {
            return t.options.every(function (t, e) {
              return t == n[e];
            });
          }),
          o = t.parentNode.querySelector(this.priceRegularSelectors),
          a = t.parentNode.querySelectorAll(this.priceCompareSelectors);
        i
          ? (o && (o.innerHTML = this.formatMoney(i.price)),
            a.length &&
              a.forEach(function (t) {
                t && (t.style.display = "none");
              }),
            this.changeImage(t, i))
          : n.length === this.collectionProducts[e].options.length &&
            o &&
            (o.innerHTML = "Unavailable");
      },
      getAvailableVariantOptions: function (t) {
        var e = [];
        return (
          t.forEach(function (t) {
            t.available && e.push(Sn(t.options));
          }),
          e
        );
      },
      isArrayEqual: function (t, e) {
        if (t.length !== e.length) return !1;
        for (var r = 0; r < t.length; r++) if (!e.includes(t[r])) return !1;
        return !0;
      },
      disableVariantNotAvailable: function (t, e) {
        var r = this;
        (!varioCustomizer.sold_out.show_sold_out_variants ||
          (this.collectionProducts[e].currentOptionSelected.length &&
            this.collectionProducts[e].options.length ===
              this.collectionProducts[e].currentOptionSelected.filter(Boolean)
                .length)) &&
          t.forEach(function (t, n) {
            t.querySelectorAll(".vario-variant").forEach(function (t) {
              var n = t.getAttribute("data-value"),
                i = t.getAttribute("data-position"),
                o = (t.getAttribute("data-option"), []);
              if (
                (((o = Sn(r.collectionProducts[e].currentOptionSelected))[i] =
                  n),
                r.collectionProducts[e].variantsAvailable.find(function (t) {
                  return r.isArrayEqual(t, o);
                }))
              )
                t.classList.remove(
                  "vario-disabled",
                  "vario-disabled-grayscale",
                  "vario-disabled-hidden"
                );
              else if (varioCustomizer.sold_out.show_sold_out_variants)
                "gray-out" === varioCustomizer.sold_out.style
                  ? t.classList.add("vario-disabled-grayscale")
                  : "cross" === varioCustomizer.sold_out.style &&
                    t.classList.add("vario-disabled");
              else {
                if (
                  !varioCustomizer.sold_out.show_sold_out_variants &&
                  r.collectionProducts[e].currentOptionSelected[i] === n
                )
                  return;
                t.classList.add("vario-disabled-hidden");
              }
            });
          });
      },
    };
  (Tn = function () {
    var t = window.meta.page.pageType;
    "collection" === t
      ? (885 === Shopify.theme.theme_store_id &&
          document.body.classList.add("vario-body"),
        kn.init())
      : "product" === t && On.init();
  }),
    (
      document.attachEvent
        ? "complete" === document.readyState
        : "loading" !== document.readyState
    )
      ? Tn()
      : document.addEventListener("DOMContentLoaded", Tn),
    (window.Vario = On),
    (window.VarioCollection = kn);
})();
